//only for testing

export const eventData = {
    code: 200,
    message: 'SUCCESS',
    data: [
        {
            start: '2023-01-05T00:00:00.000-07:00',
            end: '2023-01-05T00:30:00.000-07:00',
            providerId: null,
            eventId: '7174166edi63pj1rlaki8c7e3l_20230105T070000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                '刘晓聪 邀请您参加腾讯会议<br>会议主题：Klarity FE Weekly<br>会议时间：2022/12/08 15:00-15:30 (GMT+08:00) 中国标准时间 - 北京<br>重复周期：2022/12/08-2023/01/19 15:00-15:30, 每周 (周四)<br><br>点击链接入会，或添加至会议列表：<br><a href="https://meeting.tencent.com/dm/XmVeUZ73L3Z4">https://meeting.tencent.com/dm/XmVeUZ73L3Z4</a><br><br>#腾讯会议：889-5858-6782<br><br>复制该信息，打开手机腾讯会议即可参与',
            email: [
                'youming.tang@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
                'kunqian.fan@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'FE - weekly follow up',
            timeZone: null,
        },
        {
            start: '2023-01-05T00:00:00.000-07:00',
            end: '2023-01-06T00:00:00.000-07:00',
            providerId: null,
            eventId: '7p3t72eu7slc369bu85r17v8b8_20230105T070000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: null,
            timeZone: null,
        },
        {
            start: '2023-01-05T09:00:00.000-07:00',
            end: '2023-01-05T17:00:00.000-07:00',
            providerId: null,
            eventId: '2kep3qjcqu11nfum4ffg0otug4_20230105T160000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: "A chance to hear more about Google's developer products.",
            email: ['youming.tang@helloklarity.com', 'xiaocong.liu@helloklarity.com'],
            location: '800 Howard St., San Francisco, CA 94103',
            recurrence: null,
            summary: 'Test Event -Xiaocong',
            timeZone: null,
        },
        null,
        null,
        null,
        null,
        null,
        {
            start: '2023-01-05T11:00:00.000-07:00',
            end: '2023-01-05T12:00:00.000-07:00',
            providerId: null,
            eventId: '1tiks40ld3074d8h6br6d765fc',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'tre',
            timeZone: null,
        },
        {
            start: '2023-01-05T17:15:00.000-07:00',
            end: '2023-01-05T18:00:00.000-07:00',
            providerId: null,
            eventId: '3atu6a2t3gd4ltjquere2afe82_20230104T001500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['xiaocong.liu@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Xiaocong:Guorui weekly 1-1',
            timeZone: null,
        },
        {
            start: '2023-01-06T00:00:00.000-07:00',
            end: '2023-01-07T00:00:00.000-07:00',
            providerId: null,
            eventId: '7p3t72eu7slc369bu85r17v8b8_20230106T070000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: null,
            timeZone: null,
        },
        {
            start: '2023-01-06T09:00:00.000-07:00',
            end: '2023-01-06T17:00:00.000-07:00',
            providerId: null,
            eventId: '2kep3qjcqu11nfum4ffg0otug4_20230106T160000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: "A chance to hear more about Google's developer products.",
            email: ['youming.tang@helloklarity.com', 'xiaocong.liu@helloklarity.com'],
            location: '800 Howard St., San Francisco, CA 94103',
            recurrence: null,
            summary: 'Test Event -Xiaocong',
            timeZone: null,
        },
        null,
        null,
        null,
        null,
        null,
        {
            start: '2023-01-07T00:00:00.000-07:00',
            end: '2023-01-08T00:00:00.000-07:00',
            providerId: null,
            eventId: '7p3t72eu7slc369bu85r17v8b8_20230107T070000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: null,
            timeZone: null,
        },
        null,
        {
            start: '2023-01-08T00:00:00.000-07:00',
            end: '2023-01-09T00:00:00.000-07:00',
            providerId: null,
            eventId: '7p3t72eu7slc369bu85r17v8b8_20230108T070000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: null,
            timeZone: null,
        },
        null,
        {
            start: '2023-01-09T00:00:00.000-07:00',
            end: '2023-01-10T00:00:00.000-07:00',
            providerId: null,
            eventId: '7p3t72eu7slc369bu85r17v8b8_20230109T070000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: null,
            timeZone: null,
        },
        {
            start: '2023-01-09T18:00:00.000-07:00',
            end: '2023-01-09T18:45:00.000-07:00',
            providerId: null,
            eventId: 'vn4u8qm68a66iaqc9n6s41rsft_20230110T010000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                'Notes:&nbsp;<a href="https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c" style="background-color: var(--textfield-surface);">https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c</a>',
            email: [
                'youming.tang@helloklarity.com',
                'xiaohong.wu@helloklarity.com',
                'catherine.zhang@helloklarity.com',
                'guorui.su@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'BoxPractice Sprint (2/2) - ProviderExperience',
            timeZone: null,
        },
        {
            start: '2023-01-10T00:00:00.000-07:00',
            end: '2023-01-11T00:00:00.000-07:00',
            providerId: null,
            eventId: '7p3t72eu7slc369bu85r17v8b8_20230110T070000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: null,
            timeZone: null,
        },
        {
            start: '2023-01-10T07:00:00.000-07:00',
            end: '2023-01-10T07:45:00.000-07:00',
            providerId: null,
            eventId: '2tmcnm9ops0t6s0pt64dk6gln1',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                '刘晓聪 邀请您参加腾讯会议<br />会议主题：刘晓聪预定的会议<br />会议时间：2023/01/10 22:00-22:45 (GMT+08:00) 中国标准时间 - 北京<br /><br />点击链接入会，或添加至会议列表：<br /><a href="https://meeting.tencent.com/dm/wyw1reJ7NDri">https://meeting.tencent.com/dm/wyw1reJ7NDri</a><br /><br />#腾讯会议：777-808-526<br /><br />复制该信息，打开手机腾讯会议即可参与<br />',
            email: [
                'xiaocong.liu@helloklarity.com',
                'jason.shao@helloklarity.com',
                'xiaohong.wu@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'Google calendar 授权与同步',
            timeZone: null,
        },
        {
            start: '2023-01-10T08:15:00.000-07:00',
            end: '2023-01-10T09:00:00.000-07:00',
            providerId: null,
            eventId: 's0h331gf0pplirvnam33tocqba_20230110T151500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                '<html-blob><u></u><br><u></u><br><u></u>We\'ll use this doc for meeting note:&nbsp;<a href="https://www.notion.so/klarityhealth/Meeting-Notes-65dc7d8d16fb4a4d9ebb18c2c985771a" id="ow684" __is_owner="true">https://www.notion.so/klarityhealth/Meeting-Notes-65dc7d8d16fb4a4d9ebb18c2c985771a</a><br><br><br><u></u>Su Guorui invites you to a meeting on VooV Meeting<br>Meeting Topic: Product Weekly<br>Meeting Time: 2022/09/06 08:00-09:00 (GMT-07:00) Pacific Time - Los Angeles<br>Recurrence: 2022/09/06-2023/09/05 08:00-09:00, Every Tuesday<br><br>Click the link to join the meeting or to add it to your meeting list:<br><a href="https://voovmeeting.com/dm/5j0Pkqqp5QGM">https://voovmeeting.com/dm/5j0Pkqqp5QGM</a><br><br>#VooVMeeting：368-0734-7269<u></u></html-blob>',
            email: [
                'cecilia.zhao@helloklarity.com',
                'guorui.su@helloklarity.com',
                'jason.shao@helloklarity.com',
                'stacey.yao@helloklarity.com',
                'mark.ma@helloklarity.com',
                'kunqian.fan@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
                'aditya.joshi@helloklarity.com',
            ],
            location: 'https://voovmeeting.com/dm/5j0Pkqqp5QGM',
            recurrence: null,
            summary: 'Marketplace Product Weekly / Sprint ',
            timeZone: null,
        },
        {
            start: '2023-01-10T18:00:00.000-07:00',
            end: '2023-01-10T18:45:00.000-07:00',
            providerId: null,
            eventId: 'ff1f11k3rs35pdkcn571jm95on_20230111T010000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                'Co-working on product, tech, and design roadmap for our BoxPractice (SaaS Product)<br><br>Ongoing Meeting Notes:&nbsp;<a href="https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c">https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c</a><br><br>Guorui Su is inviting you to a scheduled Zoom meeting.<br><br><br>Join Zoom Meeting<br><a href="https://us06web.zoom.us/j/82823032706?pwd=RFVLcVZRVC9qQTRRaDlrM0haWnF2Zz09">https://us06web.zoom.us/j/82823032706?pwd=RFVLcVZRVC9qQTRRaDlrM0haWnF2Zz09</a><br><br>Meeting ID: 828 2303 2706<br>Passcode: 842013<br>One tap mobile<br>+16694449171,,82823032706#,,,,*842013# US<br>+16699006833,,82823032706#,,,,*842013# US (San Jose)<br><br>Dial by your location<br>&nbsp; &nbsp; &nbsp; &nbsp; +1 669 444 9171 US<br>&nbsp; &nbsp; &nbsp; &nbsp; +1 669 900 6833 US (San Jose)<br>&nbsp; &nbsp; &nbsp; &nbsp; +1 346 248 7799 US (Houston)<br>&nbsp; &nbsp; &nbsp; &nbsp; +1 719 359 4580 US<br>&nbsp; &nbsp; &nbsp; &nbsp; +1 253 205 0468 US<br>&nbsp; &nbsp; &nbsp; &nbsp; +1 253 215 8782 US (Tacoma)<br>&nbsp; &nbsp; &nbsp; &nbsp; +1 360 209 5623 US<br>&nbsp; &nbsp; &nbsp; &nbsp; +1 386 347 5053 US<br>&nbsp; &nbsp; &nbsp; &nbsp; +1 507 473 4847 US<br>&nbsp; &nbsp; &nbsp; &nbsp; +1 564 217 2000 US<br>&nbsp; &nbsp; &nbsp; &nbsp; +1 646 931 3860 US<br>&nbsp; &nbsp; &nbsp; &nbsp; +1 689 278 1000 US<br>&nbsp; &nbsp; &nbsp; &nbsp; +1 929 205 6099 US (New York)<br>&nbsp; &nbsp; &nbsp; &nbsp; +1 301 715 8592 US (Washington DC)<br>&nbsp; &nbsp; &nbsp; &nbsp; +1 305 224 1968 US<br>&nbsp; &nbsp; &nbsp; &nbsp; +1 309 205 3325 US<br>&nbsp; &nbsp; &nbsp; &nbsp; +1 312 626 6799 US (Chicago)<br>Meeting ID: 828 2303 2706<br>Passcode: 842013<br>Find your local number: <a href="https://us06web.zoom.us/u/kbQvKVUbHV">https://us06web.zoom.us/u/kbQvKVUbHV</a>',
            email: [
                'xiaohong.wu@helloklarity.com',
                'guorui.su@helloklarity.com',
                'cecilia.zhao@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
                'kunqian.fan@helloklarity.com',
                'zhengkai.zou@helloklarity.com',
                'jason.shao@helloklarity.com',
            ],
            location:
                ' https://us06web.zoom.us/j/82823032706?pwd=RFVLcVZRVC9qQTRRaDlrM0haWnF2Zz09',
            recurrence: null,
            summary: 'BoxPractice Sprint (1/2)- Channels / PF / PPP',
            timeZone: null,
        },
        {
            start: '2023-01-10T21:30:00.000-07:00',
            end: '2023-01-10T22:30:00.000-07:00',
            providerId: null,
            eventId: '72c6v7vg2ve1nlcpecd2svllkc',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '11',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: '111',
            timeZone: null,
        },
        {
            start: '2023-01-11T00:00:00.000-07:00',
            end: '2023-01-12T00:00:00.000-07:00',
            providerId: null,
            eventId: '7p3t72eu7slc369bu85r17v8b8_20230111T070000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: null,
            timeZone: null,
        },
        {
            start: '2023-01-11T07:00:00.000-07:00',
            end: '2023-01-11T08:00:00.000-07:00',
            providerId: null,
            eventId: '2dahq63e80cknvest5bnf6qkin_20230111T140000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: [
                'youming.tang@helloklarity.com',
                'xiaohong.wu@helloklarity.com',
                'catherine.zhang@helloklarity.com',
                'cecilia.zhao@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'BoxPractice Dev and Design Connect',
            timeZone: null,
        },
        null,
        null,
        null,
        {
            start: '2023-01-12T00:00:00.000-07:00',
            end: '2023-01-12T00:30:00.000-07:00',
            providerId: null,
            eventId: '7174166edi63pj1rlaki8c7e3l_20230112T070000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                '刘晓聪 邀请您参加腾讯会议<br>会议主题：Klarity FE Weekly<br>会议时间：2022/12/08 15:00-15:30 (GMT+08:00) 中国标准时间 - 北京<br>重复周期：2022/12/08-2023/01/19 15:00-15:30, 每周 (周四)<br><br>点击链接入会，或添加至会议列表：<br><a href="https://meeting.tencent.com/dm/XmVeUZ73L3Z4">https://meeting.tencent.com/dm/XmVeUZ73L3Z4</a><br><br>#腾讯会议：889-5858-6782<br><br>复制该信息，打开手机腾讯会议即可参与',
            email: [
                'youming.tang@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
                'kunqian.fan@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'FE - weekly follow up',
            timeZone: null,
        },
        {
            start: '2023-01-12T00:00:00.000-07:00',
            end: '2023-01-13T00:00:00.000-07:00',
            providerId: null,
            eventId: '7p3t72eu7slc369bu85r17v8b8_20230112T070000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: null,
            timeZone: null,
        },
        {
            start: '2023-01-12T17:30:00.000-07:00',
            end: '2023-01-12T18:00:00.000-07:00',
            providerId: null,
            eventId: '3atu6a2t3gd4ltjquere2afe82_20230111T001500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['xiaocong.liu@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Xiaocong:Guorui weekly 1-1',
            timeZone: null,
        },
        {
            start: '2023-01-13T00:00:00.000-07:00',
            end: '2023-01-14T00:00:00.000-07:00',
            providerId: null,
            eventId: '7p3t72eu7slc369bu85r17v8b8_20230113T070000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: null,
            timeZone: null,
        },
        {
            start: '2023-01-14T00:00:00.000-07:00',
            end: '2023-01-15T00:00:00.000-07:00',
            providerId: null,
            eventId: '7p3t72eu7slc369bu85r17v8b8_20230114T070000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: null,
            timeZone: null,
        },
        {
            start: '2023-01-15T00:00:00.000-07:00',
            end: '2023-01-16T00:00:00.000-07:00',
            providerId: null,
            eventId: '7p3t72eu7slc369bu85r17v8b8_20230115T070000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: null,
            timeZone: null,
        },
        {
            start: '2023-01-16T00:00:00.000-07:00',
            end: '2023-01-17T00:00:00.000-07:00',
            providerId: null,
            eventId: '7p3t72eu7slc369bu85r17v8b8_20230116T070000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: null,
            timeZone: null,
        },
        {
            start: '2023-01-16T18:00:00.000-07:00',
            end: '2023-01-16T18:45:00.000-07:00',
            providerId: null,
            eventId: 'vn4u8qm68a66iaqc9n6s41rsft_20230117T010000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                'Notes:&nbsp;<a href="https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c" style="background-color: var(--textfield-surface);">https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c</a>',
            email: [
                'youming.tang@helloklarity.com',
                'xiaohong.wu@helloklarity.com',
                'catherine.zhang@helloklarity.com',
                'guorui.su@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'BoxPractice Sprint (2/2) - ProviderExperience',
            timeZone: null,
        },
        {
            start: '2023-01-17T00:00:00.000-07:00',
            end: '2023-01-18T00:00:00.000-07:00',
            providerId: null,
            eventId: '7p3t72eu7slc369bu85r17v8b8_20230117T070000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: null,
            timeZone: null,
        },
        null,
        {
            start: '2023-01-17T17:30:00.000-07:00',
            end: '2023-01-17T18:00:00.000-07:00',
            providerId: null,
            eventId: '3atu6a2t3gd4ltjquere2afe82_20230118T001500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: [
                'xiaocong.liu@helloklarity.com',
                'guorui.su@helloklarity.com',
                'xiaohong.wu@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'R&D manager sync - company initiatives overview',
            timeZone: null,
        },
        {
            start: '2023-01-18T00:00:00.000-07:00',
            end: '2023-01-19T00:00:00.000-07:00',
            providerId: null,
            eventId: '7p3t72eu7slc369bu85r17v8b8_20230118T070000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: null,
            timeZone: null,
        },
        {
            start: '2023-01-18T07:00:00.000-07:00',
            end: '2023-01-18T08:00:00.000-07:00',
            providerId: null,
            eventId: '2dahq63e80cknvest5bnf6qkin_20230118T140000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: [
                'youming.tang@helloklarity.com',
                'xiaohong.wu@helloklarity.com',
                'catherine.zhang@helloklarity.com',
                'cecilia.zhao@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
                'guorui.su@helloklarity.com',
                'jason.shao@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'BoxPractice Dev and Design Connect',
            timeZone: null,
        },
        {
            start: '2023-01-18T08:15:00.000-07:00',
            end: '2023-01-18T09:00:00.000-07:00',
            providerId: null,
            eventId: 's0h331gf0pplirvnam33tocqba_20230117T151500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                '<html-blob><u></u><br><u></u><br><u></u>We\'ll use this doc for meeting note:&nbsp;<a href="https://www.notion.so/klarityhealth/Meeting-Notes-65dc7d8d16fb4a4d9ebb18c2c985771a" id="ow684" __is_owner="true">https://www.notion.so/klarityhealth/Meeting-Notes-65dc7d8d16fb4a4d9ebb18c2c985771a</a><br><br><br><u></u>Su Guorui invites you to a meeting on VooV Meeting<br>Meeting Topic: Product Weekly<br>Meeting Time: 2022/09/06 08:00-09:00 (GMT-07:00) Pacific Time - Los Angeles<br>Recurrence: 2022/09/06-2023/09/05 08:00-09:00, Every Tuesday<br><br>Click the link to join the meeting or to add it to your meeting list:<br><a href="https://voovmeeting.com/dm/5j0Pkqqp5QGM">https://voovmeeting.com/dm/5j0Pkqqp5QGM</a><br><br>#VooVMeeting：368-0734-7269<u></u></html-blob>',
            email: [
                'cecilia.zhao@helloklarity.com',
                'guorui.su@helloklarity.com',
                'jason.shao@helloklarity.com',
                'stacey.yao@helloklarity.com',
                'mark.ma@helloklarity.com',
                'kunqian.fan@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
                'aditya.joshi@helloklarity.com',
            ],
            location: 'https://voovmeeting.com/dm/5j0Pkqqp5QGM',
            recurrence: null,
            summary: 'Marketplace Product Weekly / Sprint ',
            timeZone: null,
        },
        {
            start: '2023-01-18T18:00:00.000-07:00',
            end: '2023-01-18T18:45:00.000-07:00',
            providerId: null,
            eventId: 'ff1f11k3rs35pdkcn571jm95on_20230118T010000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                'Co-working on product, tech, and design roadmap for our BoxPractice (SaaS Product)<br><br>Ongoing Meeting Notes: <a href="https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c">https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c</a><br><br>Guorui Su is inviting you to a scheduled Zoom meeting.<br><br><br>Join Zoom Meeting<br><a href="https://us06web.zoom.us/j/87578773699"><u>https://us06web.zoom.us/j/87578773699</u></a>',
            email: [
                'xiaohong.wu@helloklarity.com',
                'catherine.zhang@helloklarity.com',
                'guorui.su@helloklarity.com',
                'cecilia.zhao@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
                'kunqian.fan@helloklarity.com',
                'zhengkai.zou@helloklarity.com',
                'jason.shao@helloklarity.com',
            ],
            location: 'https://us06web.zoom.us/j/87578773699',
            recurrence: null,
            summary: 'BoxPractice Sprint (1/2)- Channels / PF / PPP',
            timeZone: null,
        },
        {
            start: '2023-01-19T00:00:00.000-07:00',
            end: '2023-01-19T00:30:00.000-07:00',
            providerId: null,
            eventId: '7174166edi63pj1rlaki8c7e3l_20230119T070000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                '刘晓聪 邀请您参加腾讯会议<br>会议主题：Klarity FE Weekly<br>会议时间：2022/12/08 15:00-15:30 (GMT+08:00) 中国标准时间 - 北京<br>重复周期：2022/12/08-2023/01/19 15:00-15:30, 每周 (周四)<br><br>点击链接入会，或添加至会议列表：<br><a href="https://meeting.tencent.com/dm/XmVeUZ73L3Z4">https://meeting.tencent.com/dm/XmVeUZ73L3Z4</a><br><br>#腾讯会议：889-5858-6782<br><br>复制该信息，打开手机腾讯会议即可参与',
            email: [
                'youming.tang@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
                'kunqian.fan@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'FE - weekly follow up',
            timeZone: null,
        },
        {
            start: '2023-01-19T00:00:00.000-07:00',
            end: '2023-01-20T00:00:00.000-07:00',
            providerId: null,
            eventId: '7p3t72eu7slc369bu85r17v8b8_20230119T070000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: null,
            timeZone: null,
        },
        {
            start: '2023-01-20T00:00:00.000-07:00',
            end: '2023-01-21T00:00:00.000-07:00',
            providerId: null,
            eventId: '7p3t72eu7slc369bu85r17v8b8_20230120T070000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: null,
            timeZone: null,
        },
        {
            start: '2023-01-21T00:00:00.000-07:00',
            end: '2023-01-22T00:00:00.000-07:00',
            providerId: null,
            eventId: '7p3t72eu7slc369bu85r17v8b8_20230121T070000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: null,
            timeZone: null,
        },
        {
            start: '2023-01-22T00:00:00.000-07:00',
            end: '2023-01-23T00:00:00.000-07:00',
            providerId: null,
            eventId: '7p3t72eu7slc369bu85r17v8b8_20230122T070000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: null,
            timeZone: null,
        },
        {
            start: '2023-01-23T00:00:00.000-07:00',
            end: '2023-01-24T00:00:00.000-07:00',
            providerId: null,
            eventId: '7p3t72eu7slc369bu85r17v8b8_20230123T070000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: null,
            timeZone: null,
        },
        null,
        {
            start: '2023-01-24T00:00:00.000-07:00',
            end: '2023-01-25T00:00:00.000-07:00',
            providerId: null,
            eventId: '7p3t72eu7slc369bu85r17v8b8_20230124T070000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: null,
            timeZone: null,
        },
        null,
        null,
        {
            start: '2023-01-24T17:00:00.000-07:00',
            end: '2023-01-24T18:00:00.000-07:00',
            providerId: null,
            eventId: '0ov1qrg1bqja3bpu1kt4e1kp7j',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '2',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'test',
            timeZone: null,
        },
        null,
        null,
        {
            start: '2023-01-25T00:00:00.000-07:00',
            end: '2023-01-26T00:00:00.000-07:00',
            providerId: null,
            eventId: '7p3t72eu7slc369bu85r17v8b8_20230125T070000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: null,
            timeZone: null,
        },
        null,
        {
            start: '2023-01-25T09:00:00.000-07:00',
            end: '2023-01-30T09:00:00.000-07:00',
            providerId: null,
            eventId: 'si8eiad79iq3ccns5n5tku2jsg',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: 'xiaocong.liu@helloklarity.com',
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['xiaocong.liu@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: '不在办公室',
            timeZone: null,
        },
        null,
        {
            start: '2023-01-26T00:00:00.000-07:00',
            end: '2023-01-27T00:00:00.000-07:00',
            providerId: null,
            eventId: '7p3t72eu7slc369bu85r17v8b8_20230126T070000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: null,
            timeZone: null,
        },
        {
            start: '2023-01-27T00:00:00.000-07:00',
            end: '2023-01-28T00:00:00.000-07:00',
            providerId: null,
            eventId: '7p3t72eu7slc369bu85r17v8b8_20230127T070000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: null,
            timeZone: null,
        },
        null,
        {
            start: '2023-01-28T08:00:00.000-07:00',
            end: '2023-01-28T08:30:00.000-07:00',
            providerId: null,
            eventId: '3pmv6sh8q2khsper23mut1vc0h',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: [
                'xiaocong.liu@helloklarity.com',
                'xiaohong.wu@helloklarity.com',
                'kunqian.fan@helloklarity.com',
                'cecilia.zhao@helloklarity.com',
                'zhengkai.zou@helloklarity.com',
                'guorui.su@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'Channel Project sync',
            timeZone: null,
        },
        null,
        null,
        {
            start: '2023-01-30T18:00:00.000-07:00',
            end: '2023-01-30T18:45:00.000-07:00',
            providerId: null,
            eventId: 'vn4u8qm68a66iaqc9n6s41rsft_20230131T010000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                'Notes:&nbsp;<a href="https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c" style="background-color: var(--textfield-surface);">https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c</a>',
            email: [
                'youming.tang@helloklarity.com',
                'xiaohong.wu@helloklarity.com',
                'catherine.zhang@helloklarity.com',
                'guorui.su@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'BoxPractice Sprint (2/2) - ProviderExperience',
            timeZone: null,
        },
        null,
        null,
        {
            start: '2023-01-31T08:15:00.000-07:00',
            end: '2023-01-31T09:00:00.000-07:00',
            providerId: null,
            eventId: 's0h331gf0pplirvnam33tocqba_20230131T151500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                '<html-blob><u></u><br><u></u><br><u></u>We\'ll use this doc for meeting note:&nbsp;<a href="https://www.notion.so/klarityhealth/Meeting-Notes-65dc7d8d16fb4a4d9ebb18c2c985771a" id="ow684" __is_owner="true">https://www.notion.so/klarityhealth/Meeting-Notes-65dc7d8d16fb4a4d9ebb18c2c985771a</a><br><br><br><u></u>Su Guorui invites you to a meeting on VooV Meeting<br>Meeting Topic: Product Weekly<br>Meeting Time: 2022/09/06 08:00-09:00 (GMT-07:00) Pacific Time - Los Angeles<br>Recurrence: 2022/09/06-2023/09/05 08:00-09:00, Every Tuesday<br><br>Click the link to join the meeting or to add it to your meeting list:<br><a href="https://voovmeeting.com/dm/5j0Pkqqp5QGM">https://voovmeeting.com/dm/5j0Pkqqp5QGM</a><br><br>#VooVMeeting：368-0734-7269<u></u></html-blob>',
            email: [
                'cecilia.zhao@helloklarity.com',
                'guorui.su@helloklarity.com',
                'jason.shao@helloklarity.com',
                'stacey.yao@helloklarity.com',
                'mark.ma@helloklarity.com',
                'kunqian.fan@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
                'aditya.joshi@helloklarity.com',
            ],
            location: 'https://voovmeeting.com/dm/5j0Pkqqp5QGM',
            recurrence: null,
            summary: 'Marketplace Product Weekly / Sprint ',
            timeZone: null,
        },
        {
            start: '2023-01-31T09:00:00.000-07:00',
            end: '2023-02-01T08:30:00.000-07:00',
            providerId: null,
            eventId: '1rm1gorol3213fllnshrpgfgvb',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'xiaocong test',
            timeZone: null,
        },
        {
            start: '2023-01-31T17:15:00.000-07:00',
            end: '2023-01-31T18:00:00.000-07:00',
            providerId: null,
            eventId: '3atu6a2t3gd4ltjquere2afe82_20230201T001500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['xiaocong.liu@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Xiaocong:Guorui weekly 1-1',
            timeZone: null,
        },
        {
            start: '2023-01-31T18:00:00.000-07:00',
            end: '2023-01-31T18:45:00.000-07:00',
            providerId: null,
            eventId: 'ff1f11k3rs35pdkcn571jm95on_20230201T010000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                'Co-working on product, tech, and design roadmap for our BoxPractice (SaaS Product)<br><br>Ongoing Meeting Notes: <a href="https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c">https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c</a><p><br>──────────<br><br>Guorui Su is inviting you to a scheduled Zoom meeting.<br><br>Join Zoom Meeting<br>https://us06web.zoom.us/j/85635757228?pwd=WVNnZVNWSzMzYm44N3NaejJZQkg0UT09<br><br>Meeting ID: 856 3575 7228<br>Passcode: 995654<br><br><br><br>──────────</p>',
            email: [
                'xiaohong.wu@helloklarity.com',
                'catherine.zhang@helloklarity.com',
                'guorui.su@helloklarity.com',
                'cecilia.zhao@helloklarity.com',
                'youming.tang@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
                'kunqian.fan@helloklarity.com',
                'zhengkai.zou@helloklarity.com',
                'jason.shao@helloklarity.com',
            ],
            location:
                'https://us06web.zoom.us/j/85635757228?pwd=WVNnZVNWSzMzYm44N3NaejJZQkg0UT09',
            recurrence: null,
            summary: 'BoxPractice Sprint (1/2)- Channels / PF / PPP',
            timeZone: null,
        },
        null,
        {
            start: '2023-02-01T07:00:00.000-07:00',
            end: '2023-02-01T08:00:00.000-07:00',
            providerId: null,
            eventId: '2dahq63e80cknvest5bnf6qkin_20230201T140000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: [
                'youming.tang@helloklarity.com',
                'xiaohong.wu@helloklarity.com',
                'catherine.zhang@helloklarity.com',
                'cecilia.zhao@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'BoxPractice Dev and Design Connect',
            timeZone: null,
        },
        null,
        null,
        {
            start: '2023-02-02T08:00:00.000-07:00',
            end: '2023-02-02T08:30:00.000-07:00',
            providerId: null,
            eventId: '5vm8b8b6aosjaegldkd1d72ogm',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: [
                'xiaocong.liu@helloklarity.com',
                'xiaohong.wu@helloklarity.com',
                'catherine.zhang@helloklarity.com',
                'jason.shao@helloklarity.com',
                'guorui.su@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'IntakeQ调研结果跟进',
            timeZone: null,
        },
        {
            start: '2023-02-02T17:30:00.000-07:00',
            end: '2023-02-02T18:15:00.000-07:00',
            providerId: null,
            eventId: 'kag2iq9dqpadp090gkvb77jc4o',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: 'name',
            patientPhone: null,
            sendForm: null,
            colorId: '2',
            description: 'Appointment with name',
            email: ['evanliu.it@gmail.com'],
            location: 'sssdd',
            recurrence: null,
            summary: 'Appointment with name',
            timeZone: null,
        },
        {
            start: '2023-02-02T18:30:00.000-07:00',
            end: '2023-02-02T20:30:00.000-07:00',
            providerId: null,
            eventId: 'v5o2ljs1lr3qb7i746vekfhnm8',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: 'name',
            patientPhone: null,
            sendForm: null,
            colorId: '1',
            description: 'Appointment with name',
            email: ['evanliu.it@gmail.com'],
            location: '122',
            recurrence: null,
            summary: 'Appointment with name',
            timeZone: null,
        },
        null,
        null,
        null,
        {
            start: '2023-02-05T17:45:00.000-07:00',
            end: '2023-02-05T18:15:00.000-07:00',
            providerId: null,
            eventId: 'bfm332l28r8gbanf62nsh0a4cg',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: 'xiaocong test',
            patientPhone: null,
            sendForm: null,
            colorId: '2',
            description: 'Appointment with xiaocong test',
            email: ['xitest@gmail.com'],
            location: 'china',
            recurrence: null,
            summary: 'Appointment with xiaocong test',
            timeZone: null,
        },
        null,
        {
            start: '2023-02-06T17:15:00.000-07:00',
            end: '2023-02-06T17:55:00.000-07:00',
            providerId: null,
            eventId: '4m0q4mt0rf09337i159nikt697',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: [
                'catherine.zhang@helloklarity.com',
                'cecilia.zhao@helloklarity.com',
                'aditya.joshi@helloklarity.com',
                'guorui.su@helloklarity.com',
                'xiaohong.wu@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'BP Product Roadmap Sync',
            timeZone: null,
        },
        {
            start: '2023-02-06T18:00:00.000-07:00',
            end: '2023-02-06T18:45:00.000-07:00',
            providerId: null,
            eventId: 'vn4u8qm68a66iaqc9n6s41rsft_20230207T010000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                'Notes: <a href="https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c">https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c</a><p><br>──────────<br><br>Guorui Su is inviting you to a scheduled Zoom meeting.<br><br>Join Zoom Meeting<br>https://us06web.zoom.us/j/87858452164?pwd=RTNqcXhEdmozOS9YNHdMQ1Z0c2dMdz09<br><br>Meeting ID: 878 5845 2164<br>Passcode: 330782<br><br><br><br>──────────</p>',
            email: [
                'youming.tang@helloklarity.com',
                'xiaohong.wu@helloklarity.com',
                'catherine.zhang@helloklarity.com',
                'guorui.su@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
            ],
            location:
                'https://us06web.zoom.us/j/87858452164?pwd=RTNqcXhEdmozOS9YNHdMQ1Z0c2dMdz09',
            recurrence: null,
            summary: 'BoxPractice Sprint (2/2) - ProviderExperience',
            timeZone: null,
        },
        null,
        null,
        {
            start: '2023-02-07T08:15:00.000-07:00',
            end: '2023-02-07T09:00:00.000-07:00',
            providerId: null,
            eventId: 's0h331gf0pplirvnam33tocqba_20230207T151500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                '<html-blob><u></u><br><u></u><br><u></u>We\'ll use this doc for meeting note:&nbsp;<a href="https://www.notion.so/klarityhealth/Meeting-Notes-65dc7d8d16fb4a4d9ebb18c2c985771a" id="ow684" __is_owner="true">https://www.notion.so/klarityhealth/Meeting-Notes-65dc7d8d16fb4a4d9ebb18c2c985771a</a><br><br><br><u></u>Su Guorui invites you to a meeting on VooV Meeting<br>Meeting Topic: Product Weekly<br>Meeting Time: 2022/09/06 08:00-09:00 (GMT-07:00) Pacific Time - Los Angeles<br>Recurrence: 2022/09/06-2023/09/05 08:00-09:00, Every Tuesday<br><br>Click the link to join the meeting or to add it to your meeting list:<br><a href="https://voovmeeting.com/dm/5j0Pkqqp5QGM">https://voovmeeting.com/dm/5j0Pkqqp5QGM</a><br><br>#VooVMeeting：368-0734-7269<u></u></html-blob>',
            email: [
                'cecilia.zhao@helloklarity.com',
                'guorui.su@helloklarity.com',
                'jason.shao@helloklarity.com',
                'stacey.yao@helloklarity.com',
                'mark.ma@helloklarity.com',
                'kunqian.fan@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
                'aditya.joshi@helloklarity.com',
            ],
            location: 'https://voovmeeting.com/dm/5j0Pkqqp5QGM',
            recurrence: null,
            summary: 'Marketplace Product Weekly / Sprint ',
            timeZone: null,
        },
        {
            start: '2023-02-07T18:00:00.000-07:00',
            end: '2023-02-07T18:45:00.000-07:00',
            providerId: null,
            eventId: 'ff1f11k3rs35pdkcn571jm95on_20230208T010000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                'Co-working on product, tech, and design roadmap for our BoxPractice (SaaS Product)<br><br>Ongoing Meeting Notes: <a href="https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c">https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c</a><p><br>──────────<br><br>Guorui Su is inviting you to a scheduled Zoom meeting.<br><br>Join Zoom Meeting<br>https://us06web.zoom.us/j/85635757228?pwd=WVNnZVNWSzMzYm44N3NaejJZQkg0UT09<br><br>Meeting ID: 856 3575 7228<br>Passcode: 995654<br><br><br><br>──────────</p>',
            email: [
                'xiaohong.wu@helloklarity.com',
                'catherine.zhang@helloklarity.com',
                'guorui.su@helloklarity.com',
                'cecilia.zhao@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
                'kunqian.fan@helloklarity.com',
                'zhengkai.zou@helloklarity.com',
                'jason.shao@helloklarity.com',
            ],
            location:
                'https://us06web.zoom.us/j/85635757228?pwd=WVNnZVNWSzMzYm44N3NaejJZQkg0UT09',
            recurrence: null,
            summary: 'BoxPractice Sprint (1/2)- Channels / PF / PPP',
            timeZone: null,
        },
        null,
        {
            start: '2023-02-08T07:00:00.000-07:00',
            end: '2023-02-08T08:00:00.000-07:00',
            providerId: null,
            eventId: '2dahq63e80cknvest5bnf6qkin_20230208T140000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: [
                'youming.tang@helloklarity.com',
                'xiaohong.wu@helloklarity.com',
                'catherine.zhang@helloklarity.com',
                'cecilia.zhao@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'BoxPractice Dev and Design Connect',
            timeZone: null,
        },
        {
            start: '2023-02-09T00:00:00.000-07:00',
            end: '2023-02-09T00:30:00.000-07:00',
            providerId: null,
            eventId: '7174166edi63pj1rlaki8c7e3l_20230209T070000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                '刘晓聪 邀请您参加腾讯会议<br>会议主题：Klarity FE Weekly<br>会议时间：2022/12/08 15:00-15:30 (GMT+08:00) 中国标准时间 - 北京<br>重复周期：2022/12/08-2023/01/19 15:00-15:30, 每周 (周四)<br><br>点击链接入会，或添加至会议列表：<br><a href="https://meeting.tencent.com/dm/XmVeUZ73L3Z4">https://meeting.tencent.com/dm/XmVeUZ73L3Z4</a><br><br>#腾讯会议：889-5858-6782<br><br>复制该信息，打开手机腾讯会议即可参与',
            email: [
                'youming.tang@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
                'kunqian.fan@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'FE - weekly follow up',
            timeZone: null,
        },
        null,
        {
            start: '2023-02-09T17:15:00.000-07:00',
            end: '2023-02-09T18:00:00.000-07:00',
            providerId: null,
            eventId: '3atu6a2t3gd4ltjquere2afe82_20230208T001500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['xiaocong.liu@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Xiaocong:Guorui weekly 1-1',
            timeZone: null,
        },
        null,
        null,
        null,
        null,
        {
            start: '2023-02-13T18:00:00.000-07:00',
            end: '2023-02-13T18:45:00.000-07:00',
            providerId: null,
            eventId: 'vn4u8qm68a66iaqc9n6s41rsft_20230214T010000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                'Notes: <a href="https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c">https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c</a><p><br>──────────<br><br>Guorui Su is inviting you to a scheduled Zoom meeting.<br><br>Join Zoom Meeting<br>https://us06web.zoom.us/j/87858452164?pwd=RTNqcXhEdmozOS9YNHdMQ1Z0c2dMdz09<br><br>Meeting ID: 878 5845 2164<br>Passcode: 330782<br><br><br><br>──────────</p>',
            email: [
                'youming.tang@helloklarity.com',
                'xiaohong.wu@helloklarity.com',
                'catherine.zhang@helloklarity.com',
                'guorui.su@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
            ],
            location:
                'https://us06web.zoom.us/j/87858452164?pwd=RTNqcXhEdmozOS9YNHdMQ1Z0c2dMdz09',
            recurrence: null,
            summary: 'BoxPractice Sprint (2/2) - ProviderExperience',
            timeZone: null,
        },
        null,
        null,
        {
            start: '2023-02-14T08:15:00.000-07:00',
            end: '2023-02-14T09:00:00.000-07:00',
            providerId: null,
            eventId: 's0h331gf0pplirvnam33tocqba_20230214T151500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                '<html-blob><u></u><br><u></u><br><u></u>We\'ll use this doc for meeting note:&nbsp;<a href="https://www.notion.so/klarityhealth/Meeting-Notes-65dc7d8d16fb4a4d9ebb18c2c985771a" id="ow684" __is_owner="true">https://www.notion.so/klarityhealth/Meeting-Notes-65dc7d8d16fb4a4d9ebb18c2c985771a</a><br><br><br><u></u>Su Guorui invites you to a meeting on VooV Meeting<br>Meeting Topic: Product Weekly<br>Meeting Time: 2022/09/06 08:00-09:00 (GMT-07:00) Pacific Time - Los Angeles<br>Recurrence: 2022/09/06-2023/09/05 08:00-09:00, Every Tuesday<br><br>Click the link to join the meeting or to add it to your meeting list:<br><a href="https://voovmeeting.com/dm/5j0Pkqqp5QGM">https://voovmeeting.com/dm/5j0Pkqqp5QGM</a><br><br>#VooVMeeting：368-0734-7269<u></u></html-blob>',
            email: [
                'cecilia.zhao@helloklarity.com',
                'guorui.su@helloklarity.com',
                'jason.shao@helloklarity.com',
                'stacey.yao@helloklarity.com',
                'mark.ma@helloklarity.com',
                'kunqian.fan@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
                'aditya.joshi@helloklarity.com',
            ],
            location: 'https://voovmeeting.com/dm/5j0Pkqqp5QGM',
            recurrence: null,
            summary: 'Marketplace Product Weekly / Sprint ',
            timeZone: null,
        },
        {
            start: '2023-02-14T17:15:00.000-07:00',
            end: '2023-02-14T18:00:00.000-07:00',
            providerId: null,
            eventId: '3atu6a2t3gd4ltjquere2afe82_20230215T001500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['xiaocong.liu@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Xiaocong:Guorui weekly 1-1',
            timeZone: null,
        },
        {
            start: '2023-02-14T18:00:00.000-07:00',
            end: '2023-02-14T18:45:00.000-07:00',
            providerId: null,
            eventId: 'ff1f11k3rs35pdkcn571jm95on_20230215T010000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                'Co-working on product, tech, and design roadmap for our BoxPractice (SaaS Product)<br><br>Ongoing Meeting Notes: <a href="https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c">https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c</a><p><br>──────────<br><br>Guorui Su is inviting you to a scheduled Zoom meeting.<br><br>Join Zoom Meeting<br>https://us06web.zoom.us/j/85635757228?pwd=WVNnZVNWSzMzYm44N3NaejJZQkg0UT09<br><br>Meeting ID: 856 3575 7228<br>Passcode: 995654<br><br><br><br>──────────</p>',
            email: [
                'xiaohong.wu@helloklarity.com',
                'catherine.zhang@helloklarity.com',
                'guorui.su@helloklarity.com',
                'cecilia.zhao@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
                'kunqian.fan@helloklarity.com',
                'zhengkai.zou@helloklarity.com',
                'jason.shao@helloklarity.com',
            ],
            location:
                'https://us06web.zoom.us/j/85635757228?pwd=WVNnZVNWSzMzYm44N3NaejJZQkg0UT09',
            recurrence: null,
            summary: 'BoxPractice Sprint (1/2)- Channels / PF / PPP',
            timeZone: null,
        },
        null,
        {
            start: '2023-02-15T07:00:00.000-07:00',
            end: '2023-02-15T08:00:00.000-07:00',
            providerId: null,
            eventId: '2dahq63e80cknvest5bnf6qkin_20230215T140000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: [
                'youming.tang@helloklarity.com',
                'xiaohong.wu@helloklarity.com',
                'catherine.zhang@helloklarity.com',
                'cecilia.zhao@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'BoxPractice Dev and Design Connect',
            timeZone: null,
        },
        {
            start: '2023-02-16T00:00:00.000-07:00',
            end: '2023-02-16T00:30:00.000-07:00',
            providerId: null,
            eventId: '7174166edi63pj1rlaki8c7e3l_20230216T070000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                '刘晓聪 邀请您参加腾讯会议<br>会议主题：Klarity FE Weekly<br>会议时间：2022/12/08 15:00-15:30 (GMT+08:00) 中国标准时间 - 北京<br>重复周期：2022/12/08-2023/01/19 15:00-15:30, 每周 (周四)<br><br>点击链接入会，或添加至会议列表：<br><a href="https://meeting.tencent.com/dm/XmVeUZ73L3Z4">https://meeting.tencent.com/dm/XmVeUZ73L3Z4</a><br><br>#腾讯会议：889-5858-6782<br><br>复制该信息，打开手机腾讯会议即可参与',
            email: [
                'youming.tang@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
                'kunqian.fan@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'FE - weekly follow up',
            timeZone: null,
        },
        null,
        null,
        null,
        null,
        null,
        {
            start: '2023-02-20T18:00:00.000-07:00',
            end: '2023-02-20T18:45:00.000-07:00',
            providerId: null,
            eventId: 'vn4u8qm68a66iaqc9n6s41rsft_20230221T010000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                'Notes: <a href="https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c">https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c</a><p><br>──────────<br><br>Guorui Su is inviting you to a scheduled Zoom meeting.<br><br>Join Zoom Meeting<br>https://us06web.zoom.us/j/87858452164?pwd=RTNqcXhEdmozOS9YNHdMQ1Z0c2dMdz09<br><br>Meeting ID: 878 5845 2164<br>Passcode: 330782<br><br><br><br>──────────</p>',
            email: [
                'youming.tang@helloklarity.com',
                'xiaohong.wu@helloklarity.com',
                'catherine.zhang@helloklarity.com',
                'guorui.su@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
            ],
            location:
                'https://us06web.zoom.us/j/87858452164?pwd=RTNqcXhEdmozOS9YNHdMQ1Z0c2dMdz09',
            recurrence: null,
            summary: 'BoxPractice Sprint (2/2) - ProviderExperience',
            timeZone: null,
        },
        null,
        null,
        {
            start: '2023-02-21T08:15:00.000-07:00',
            end: '2023-02-21T09:00:00.000-07:00',
            providerId: null,
            eventId: 's0h331gf0pplirvnam33tocqba_20230221T151500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                '<html-blob><u></u><br><u></u><br><u></u>We\'ll use this doc for meeting note:&nbsp;<a href="https://www.notion.so/klarityhealth/Meeting-Notes-65dc7d8d16fb4a4d9ebb18c2c985771a" id="ow684" __is_owner="true">https://www.notion.so/klarityhealth/Meeting-Notes-65dc7d8d16fb4a4d9ebb18c2c985771a</a><br><br><br><u></u>Su Guorui invites you to a meeting on VooV Meeting<br>Meeting Topic: Product Weekly<br>Meeting Time: 2022/09/06 08:00-09:00 (GMT-07:00) Pacific Time - Los Angeles<br>Recurrence: 2022/09/06-2023/09/05 08:00-09:00, Every Tuesday<br><br>Click the link to join the meeting or to add it to your meeting list:<br><a href="https://voovmeeting.com/dm/5j0Pkqqp5QGM">https://voovmeeting.com/dm/5j0Pkqqp5QGM</a><br><br>#VooVMeeting：368-0734-7269<u></u></html-blob>',
            email: [
                'cecilia.zhao@helloklarity.com',
                'guorui.su@helloklarity.com',
                'jason.shao@helloklarity.com',
                'stacey.yao@helloklarity.com',
                'mark.ma@helloklarity.com',
                'kunqian.fan@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
                'aditya.joshi@helloklarity.com',
            ],
            location: 'https://voovmeeting.com/dm/5j0Pkqqp5QGM',
            recurrence: null,
            summary: 'Marketplace Product Weekly / Sprint ',
            timeZone: null,
        },
        {
            start: '2023-02-21T17:15:00.000-07:00',
            end: '2023-02-21T18:00:00.000-07:00',
            providerId: null,
            eventId: '3atu6a2t3gd4ltjquere2afe82_20230222T001500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['xiaocong.liu@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Xiaocong:Guorui weekly 1-1',
            timeZone: null,
        },
        {
            start: '2023-02-21T18:00:00.000-07:00',
            end: '2023-02-21T18:45:00.000-07:00',
            providerId: null,
            eventId: 'ff1f11k3rs35pdkcn571jm95on_20230222T010000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                'Co-working on product, tech, and design roadmap for our BoxPractice (SaaS Product)<br><br>Ongoing Meeting Notes: <a href="https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c">https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c</a><p><br>──────────<br><br>Guorui Su is inviting you to a scheduled Zoom meeting.<br><br>Join Zoom Meeting<br>https://us06web.zoom.us/j/85635757228?pwd=WVNnZVNWSzMzYm44N3NaejJZQkg0UT09<br><br>Meeting ID: 856 3575 7228<br>Passcode: 995654<br><br><br><br>──────────</p>',
            email: [
                'xiaohong.wu@helloklarity.com',
                'catherine.zhang@helloklarity.com',
                'guorui.su@helloklarity.com',
                'cecilia.zhao@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
                'kunqian.fan@helloklarity.com',
                'zhengkai.zou@helloklarity.com',
                'jason.shao@helloklarity.com',
            ],
            location:
                'https://us06web.zoom.us/j/85635757228?pwd=WVNnZVNWSzMzYm44N3NaejJZQkg0UT09',
            recurrence: null,
            summary: 'BoxPractice Sprint (1/2)- Channels / PF / PPP',
            timeZone: null,
        },
        null,
        {
            start: '2023-02-22T07:00:00.000-07:00',
            end: '2023-02-22T08:00:00.000-07:00',
            providerId: null,
            eventId: '2dahq63e80cknvest5bnf6qkin_20230222T140000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: [
                'youming.tang@helloklarity.com',
                'xiaohong.wu@helloklarity.com',
                'catherine.zhang@helloklarity.com',
                'cecilia.zhao@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'BoxPractice Dev and Design Connect',
            timeZone: null,
        },
        {
            start: '2023-02-23T00:00:00.000-07:00',
            end: '2023-02-23T00:30:00.000-07:00',
            providerId: null,
            eventId: '7174166edi63pj1rlaki8c7e3l_20230223T070000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                '刘晓聪 邀请您参加腾讯会议<br>会议主题：Klarity FE Weekly<br>会议时间：2022/12/08 15:00-15:30 (GMT+08:00) 中国标准时间 - 北京<br>重复周期：2022/12/08-2023/01/19 15:00-15:30, 每周 (周四)<br><br>点击链接入会，或添加至会议列表：<br><a href="https://meeting.tencent.com/dm/XmVeUZ73L3Z4">https://meeting.tencent.com/dm/XmVeUZ73L3Z4</a><br><br>#腾讯会议：889-5858-6782<br><br>复制该信息，打开手机腾讯会议即可参与',
            email: [
                'youming.tang@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
                'kunqian.fan@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'FE - weekly follow up',
            timeZone: null,
        },
        null,
        null,
        null,
        null,
        null,
        {
            start: '2023-02-27T18:00:00.000-07:00',
            end: '2023-02-27T18:45:00.000-07:00',
            providerId: null,
            eventId: 'vn4u8qm68a66iaqc9n6s41rsft_20230228T010000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                'Notes: <a href="https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c">https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c</a><p><br>──────────<br><br>Guorui Su is inviting you to a scheduled Zoom meeting.<br><br>Join Zoom Meeting<br>https://us06web.zoom.us/j/87858452164?pwd=RTNqcXhEdmozOS9YNHdMQ1Z0c2dMdz09<br><br>Meeting ID: 878 5845 2164<br>Passcode: 330782<br><br><br><br>──────────</p>',
            email: [
                'youming.tang@helloklarity.com',
                'xiaohong.wu@helloklarity.com',
                'catherine.zhang@helloklarity.com',
                'guorui.su@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
            ],
            location:
                'https://us06web.zoom.us/j/87858452164?pwd=RTNqcXhEdmozOS9YNHdMQ1Z0c2dMdz09',
            recurrence: null,
            summary: 'BoxPractice Sprint (2/2) - ProviderExperience',
            timeZone: null,
        },
        null,
        null,
        {
            start: '2023-02-28T08:15:00.000-07:00',
            end: '2023-02-28T09:00:00.000-07:00',
            providerId: null,
            eventId: 's0h331gf0pplirvnam33tocqba_20230228T151500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                '<html-blob><u></u><br><u></u><br><u></u>We\'ll use this doc for meeting note:&nbsp;<a href="https://www.notion.so/klarityhealth/Meeting-Notes-65dc7d8d16fb4a4d9ebb18c2c985771a" id="ow684" __is_owner="true">https://www.notion.so/klarityhealth/Meeting-Notes-65dc7d8d16fb4a4d9ebb18c2c985771a</a><br><br><br><u></u>Su Guorui invites you to a meeting on VooV Meeting<br>Meeting Topic: Product Weekly<br>Meeting Time: 2022/09/06 08:00-09:00 (GMT-07:00) Pacific Time - Los Angeles<br>Recurrence: 2022/09/06-2023/09/05 08:00-09:00, Every Tuesday<br><br>Click the link to join the meeting or to add it to your meeting list:<br><a href="https://voovmeeting.com/dm/5j0Pkqqp5QGM">https://voovmeeting.com/dm/5j0Pkqqp5QGM</a><br><br>#VooVMeeting：368-0734-7269<u></u></html-blob>',
            email: [
                'cecilia.zhao@helloklarity.com',
                'guorui.su@helloklarity.com',
                'jason.shao@helloklarity.com',
                'stacey.yao@helloklarity.com',
                'mark.ma@helloklarity.com',
                'kunqian.fan@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
                'aditya.joshi@helloklarity.com',
            ],
            location: 'https://voovmeeting.com/dm/5j0Pkqqp5QGM',
            recurrence: null,
            summary: 'Marketplace Product Weekly / Sprint ',
            timeZone: null,
        },
        {
            start: '2023-02-28T17:15:00.000-07:00',
            end: '2023-02-28T18:00:00.000-07:00',
            providerId: null,
            eventId: '3atu6a2t3gd4ltjquere2afe82_20230301T001500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['xiaocong.liu@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Xiaocong:Guorui weekly 1-1',
            timeZone: null,
        },
        {
            start: '2023-02-28T18:00:00.000-07:00',
            end: '2023-02-28T18:45:00.000-07:00',
            providerId: null,
            eventId: 'ff1f11k3rs35pdkcn571jm95on_20230301T010000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                'Co-working on product, tech, and design roadmap for our BoxPractice (SaaS Product)<br><br>Ongoing Meeting Notes: <a href="https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c">https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c</a><p><br>──────────<br><br>Guorui Su is inviting you to a scheduled Zoom meeting.<br><br>Join Zoom Meeting<br>https://us06web.zoom.us/j/85635757228?pwd=WVNnZVNWSzMzYm44N3NaejJZQkg0UT09<br><br>Meeting ID: 856 3575 7228<br>Passcode: 995654<br><br><br><br>──────────</p>',
            email: [
                'xiaohong.wu@helloklarity.com',
                'catherine.zhang@helloklarity.com',
                'guorui.su@helloklarity.com',
                'cecilia.zhao@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
                'kunqian.fan@helloklarity.com',
                'zhengkai.zou@helloklarity.com',
                'jason.shao@helloklarity.com',
            ],
            location:
                'https://us06web.zoom.us/j/85635757228?pwd=WVNnZVNWSzMzYm44N3NaejJZQkg0UT09',
            recurrence: null,
            summary: 'BoxPractice Sprint (1/2)- Channels / PF / PPP',
            timeZone: null,
        },
        null,
        {
            start: '2023-03-01T07:00:00.000-07:00',
            end: '2023-03-01T08:00:00.000-07:00',
            providerId: null,
            eventId: '2dahq63e80cknvest5bnf6qkin_20230301T140000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: [
                'youming.tang@helloklarity.com',
                'xiaohong.wu@helloklarity.com',
                'catherine.zhang@helloklarity.com',
                'cecilia.zhao@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'BoxPractice Dev and Design Connect',
            timeZone: null,
        },
        {
            start: '2023-03-02T00:00:00.000-07:00',
            end: '2023-03-02T00:30:00.000-07:00',
            providerId: null,
            eventId: '7174166edi63pj1rlaki8c7e3l_20230302T070000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                '刘晓聪 邀请您参加腾讯会议<br>会议主题：Klarity FE Weekly<br>会议时间：2022/12/08 15:00-15:30 (GMT+08:00) 中国标准时间 - 北京<br>重复周期：2022/12/08-2023/01/19 15:00-15:30, 每周 (周四)<br><br>点击链接入会，或添加至会议列表：<br><a href="https://meeting.tencent.com/dm/XmVeUZ73L3Z4">https://meeting.tencent.com/dm/XmVeUZ73L3Z4</a><br><br>#腾讯会议：889-5858-6782<br><br>复制该信息，打开手机腾讯会议即可参与',
            email: [
                'youming.tang@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
                'kunqian.fan@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'FE - weekly follow up',
            timeZone: null,
        },
        null,
        null,
        null,
    ],
};

export const provider = {
    id: 35,
    firstName: 'Xiaocong',
    lastName: 'Liu',
    email: '12184795@qq.com',
    tel: '12',
    gmail: null,
    address: 'Chaozhou , Guandong Province , China',
    zip: '521000',
    state: 'CA',
    status: 'submited',
    npi: '12222',
    yearExp: 12,
    specialityInHealth:
        'Geriatric Psychiatry,Bipoar disorder,Mood disorder,Pediatric Psychiatry',
    specialityInFamily: 'Fatigue,Anxiety,ot1,ot2',
    licenseList: [
        {
            id: 65,
            providerId: 35,
            type: 'CMEC',
            secondType: '1',
            state: 'CA',
            licenseNumber: '111',
            expireDate: null,
            schedule: null,
            licenseType: null,
            url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/6e4f95fe-f5bd-4bd2-ae76-9b7ccf892316.png',
            certificatedTitle: 'tt1',
            classTitle: 'tt2',
            hourCompleted: 23,
        },
        {
            id: 66,
            providerId: 35,
            type: 'CMEC',
            secondType: '2',
            state: 'CA',
            licenseNumber: '224',
            expireDate: null,
            schedule: null,
            licenseType: null,
            url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/292a4737-313c-42bb-b78c-4624d8ea135b.png',
            certificatedTitle: 'tt2',
            classTitle: 'ctt2',
            hourCompleted: 12,
        },
        {
            id: 64,
            providerId: 35,
            type: 'CSC',
            secondType: '1',
            state: 'CA',
            licenseNumber: '212222222',
            expireDate: '2022-12-20T00:00:00.000+00:00',
            schedule: 'Schedule I',
            licenseType: null,
            url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/1fa620b8-a82a-46dc-8db3-2910be267256.png',
            certificatedTitle: null,
            classTitle: null,
            hourCompleted: null,
        },
        {
            id: 61,
            providerId: 35,
            type: 'DEA',
            secondType: '1',
            state: 'CA',
            licenseNumber: '1222222222',
            expireDate: '2022-12-01T00:00:00.000+00:00',
            schedule: 'Schedule I',
            licenseType: null,
            url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/ebc2b95c-1890-4a0b-b474-81b790e81473.png',
            certificatedTitle: null,
            classTitle: null,
            hourCompleted: null,
        },
        {
            id: 67,
            providerId: 35,
            type: 'DEA',
            secondType: '1',
            state: 'CB',
            licenseNumber: '6666666666',
            expireDate: '2022-12-01T00:00:00.000+00:00',
            schedule: 'Schedule II',
            licenseType: null,
            url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/590c5fcf-7d80-452f-81d2-8a31895a4138.png',
            certificatedTitle: null,
            classTitle: null,
            hourCompleted: null,
        },
        {
            id: 62,
            providerId: 35,
            type: 'NURSE',
            secondType: '1',
            state: 'CA',
            licenseNumber: '1111111111',
            expireDate: '2022-10-06T00:00:00.000+00:00',
            schedule: 'Schedule I',
            licenseType:
                'abc license=https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/339c4b6a-51cd-4fdf-9dc1-77f110d9dccf.png,AGANCNP-BC=https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/67901885-503e-404b-bed5-a11f31dd6607.png',
            url: null,
            certificatedTitle: null,
            classTitle: null,
            hourCompleted: null,
        },
        {
            id: 68,
            providerId: 35,
            type: 'NURSE',
            secondType: '1',
            state: 'CB',
            licenseNumber: '3333333333',
            expireDate: '2022-12-08T00:00:00.000+00:00',
            schedule: 'Schedule I',
            licenseType:
                'AGCPNC-BC=https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/397ef967-6439-408e-8b53-13c551b947eb.png,CCRN=https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/e2735281-fd9f-4d9d-a305-923f5f326aa3.png',
            url: null,
            certificatedTitle: null,
            classTitle: null,
            hourCompleted: null,
        },
        {
            id: 63,
            providerId: 35,
            type: 'PA',
            secondType: '2',
            state: 'CA',
            licenseNumber: '2222222222',
            expireDate: '2022-12-01T00:00:00.000+00:00',
            schedule: 'Schedule I',
            licenseType: null,
            url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/e27bbfe0-6ee8-4938-8b45-571c62e9c280.png',
            certificatedTitle: null,
            classTitle: null,
            hourCompleted: null,
        },
    ],
    physicianData: [
        {
            id: 33,
            providerId: 35,
            choice: 2,
            name: null,
            email: '',
            tel: null,
            address: null,
            zip: null,
            state: 'CA',
            physicianState: null,
            npi: null,
            yearExp: null,
            licenseState: null,
            specialities: null,
            effectiveDate: null,
            expDate: null,
            url: null,
        },
        {
            id: 34,
            providerId: 35,
            choice: 3,
            name: 'xaicong',
            email: 'evanliu.it@gmail.com',
            tel: '1212',
            address: 'Chaozhou , Guandong Province , China',
            zip: '521000',
            state: 'CB',
            physicianState: 'CA',
            npi: '1222',
            yearExp: null,
            licenseState: 'CB',
            specialities: 'abc,cbd',
            effectiveDate: '2022-12-01T00:00:00.000+00:00',
            expDate: '2022-12-02T00:00:00.000+00:00',
            url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/25f41aa5-6776-46fa-87e8-2645a0653e77.png',
        },
    ],
};

// profileForm.setFieldsValue({ [ProfileFormFieldEnum.EMAIL]: user?.email });
// qualificationForm.setFieldsValue({
//     qualifications: [{
//         [QualificationFormFieldEnum.STATE]: 'CA',
//         [QualificationFormFieldEnum.DEA_LICENSES]: LicenseData.serverToForm(
//             {
//                 providerId: 23,
//                 type: 'DEA',
//                 secondType: '1',
//                 state: 'CA',
//                 licenseNumber: '1223456781',
//                 expireDate: '2022-12-17T00:00:00.000+00:00',
//                 schedule: 'Schedule I',
//                 url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/594221b1-a2cf-4a89-9f37-f5e8d316dc59.png',
//             },
//         ),
//         [QualificationFormFieldEnum.COLLABORATING_PHYSICIAN]: PhysicianData.serverToForm({
//             id: 1,
//             state: 'CA',
//             providerId: 4,
//             choice: 3,
//             name: 'uuuu',
//             email: 'evanliu@@q.com',
//             tel: '',
//             address: '',
//             zip: '123',
//             physicianState: 'CB',
//             npi: 'uuuu',
//             yearExp: 0,
//             licenseState: 'CA',
//             specialities: '',
//             effectiveDate: '2023-01-01T00:00:00.000+00:00',
//             expDate: '2023-01-01T00:00:00.000+00:00',
//             url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/1.jpeg',
//         }),
//         [QualificationFormFieldEnum.NURSE_AND_PHYSICIAN_ASSISTANT_LICENSES]: {
//             nurse: LicenseData.serverToForm({
//                 providerId: 23,
//                 type: 'NURSE',
//                 secondType: '1',
//                 state: 'CA',
//                 licenseNumber: '1333',
//                 expireDate: '2022-12-28T00:00:00.000+00:00',
//                 schedule: 'Schedule I',
//                 licenseType: 'AGANCNP-BC:https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/d7226e92-4981-443b-a6c3-b3955dd08c6c.png,abc:https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/0bd327c5-3f4f-41d5-93e2-9e37741fa862.png',
//                 url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/d7226e92-4981-443b-a6c3-b3955dd08c6c.png',
//                 certificatedTitle: 'ctitle',
//                 classTitle: 'classTitle',
//                 hourCompleted: 22,
//             }),
//         },
//         [QualificationFormFieldEnum.CONTROLLED_SUBSTANCE_CERTIFICATION]: LicenseData.serverToForm(
//             {
//                 providerId: 23,
//                 type: 'CSC',
//                 secondType: '1',
//                 state: 'CA',
//                 licenseNumber: '00129108933',
//                 expireDate: '2027-12-02T00:00:00.000+00:00',
//                 schedule: 'Schedule II',
//                 url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/d0744256-bf7e-4fd7-a1e2-5f8344fb2a91.png',
//             },
//         ),
//         [QualificationFormFieldEnum.CONTINUING_MEDICAL_EDUCATION_CERTIFICATES]: {
//             licenses: [
//                 LicenseData.serverToForm({
//                     providerId: 23,
//                     type: 'CMEC',
//                     secondType: '1',
//                     state: 'CA',
//                     licenseNumber: '33313',
//                     url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/4a3cecb0-5b0c-4b4c-96f6-36fbeb44718f.png',
//                 }),
//                 LicenseData.serverToForm({
//                     providerId: 23,
//                     type: 'CMEC',
//                     secondType: '2',
//                     state: 'CA',
//                     licenseNumber: '2221222',
//                     url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/37173b2b-0e68-4db0-9df5-e43c0460cf89.png',
//                 }),
//             ],
//         },
//     },
//     {
//         [QualificationFormFieldEnum.STATE]: 'CB',
//         [QualificationFormFieldEnum.DEA_LICENSES]: LicenseData.serverToForm(
//             {
//                 providerId: 23,
//                 type: 'DEA',
//                 secondType: '1',
//                 state: 'CA',
//                 licenseNumber: '1223456781',
//                 expireDate: '2022-12-17T00:00:00.000+00:00',
//                 schedule: 'Schedule I',
//                 url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/594221b1-a2cf-4a89-9f37-f5e8d316dc59.png',
//             },
//         ),
//         [QualificationFormFieldEnum.COLLABORATING_PHYSICIAN]: PhysicianData.serverToForm({
//             id: 1,
//             state: 'CA',
//             providerId: 4,
//             choice: 1,
//             name: 'uuuu',
//             email: 'evanliu@@q.com',
//             tel: '',
//             address: '',
//             zip: '123',
//             physicianState: 'CB',
//             npi: 'uuuu',
//             yearExp: 0,
//             licenseState: 'CA',
//             specialities: '',
//             effectiveDate: '2023-01-01T00:00:00.000+00:00',
//             expDate: '2023-01-01T00:00:00.000+00:00',
//             url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/1.jpeg',
//         }),
//         [QualificationFormFieldEnum.NURSE_AND_PHYSICIAN_ASSISTANT_LICENSES]: {
//             nurse: LicenseData.serverToForm({
//                 providerId: 23,
//                 type: 'NURSE',
//                 secondType: '1',
//                 state: 'CA',
//                 licenseNumber: '1333',
//                 expireDate: '2022-12-28T00:00:00.000+00:00',
//                 schedule: 'Schedule I',
//                 licenseType: 'AGANCNP-BC:https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/d7226e92-4981-443b-a6c3-b3955dd08c6c.png,abc:https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/0bd327c5-3f4f-41d5-93e2-9e37741fa862.png',
//                 url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/d7226e92-4981-443b-a6c3-b3955dd08c6c.png',
//                 certificatedTitle: 'ctitle',
//                 classTitle: 'classTitle',
//                 hourCompleted: 22,
//             }),
//         },
//         [QualificationFormFieldEnum.CONTROLLED_SUBSTANCE_CERTIFICATION]: LicenseData.serverToForm(
//             {
//                 providerId: 23,
//                 type: 'CSC',
//                 secondType: '1',
//                 state: 'CA',
//                 licenseNumber: '00129108933',
//                 expireDate: '2027-12-02T00:00:00.000+00:00',
//                 schedule: 'Schedule II',
//                 url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/d0744256-bf7e-4fd7-a1e2-5f8344fb2a91.png',
//             },
//         ),
//         [QualificationFormFieldEnum.CONTINUING_MEDICAL_EDUCATION_CERTIFICATES]: {
//             licenses: [
//                 LicenseData.serverToForm({
//                     providerId: 23,
//                     type: 'CMEC',
//                     secondType: '1',
//                     state: 'CA',
//                     licenseNumber: '33313',
//                     url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/4a3cecb0-5b0c-4b4c-96f6-36fbeb44718f.png',
//                 }),
//                 LicenseData.serverToForm({
//                     providerId: 23,
//                     type: 'CMEC',
//                     secondType: '2',
//                     state: 'CA',
//                     licenseNumber: '2221222',
//                     url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/37173b2b-0e68-4db0-9df5-e43c0460cf89.png',
//                 }),
//             ],
//         },
//     },
//     ],
// });
// previewForm.setFieldsValue({
//     email: 'evanliu.it@gmail.com',
//     tel: '+8613828394138',
//     address: 'Chaozhou , Guandong Province , China',
//     zip: '521000',
//     state: 'CA',
//     npi: '1222',
//     yearExp: 12,
//     specialityInHealth: 'Addiction,Geriatric Psychiatry,ooo'.split(','),
//     specialityInFamily: 'Fatigue'.split(','),

//     qualifications: [{
//         [QualificationFormFieldEnum.STATE]: 'CA',
//         [QualificationFormFieldEnum.DEA_LICENSES]: LicenseData.serverToForm(
//             {
//                 providerId: 23,
//                 type: 'DEA',
//                 secondType: '1',
//                 state: 'CA',
//                 licenseNumber: '1223456781',
//                 expireDate: '2022-12-17T00:00:00.000+00:00',
//                 schedule: 'Schedule I',
//                 url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/594221b1-a2cf-4a89-9f37-f5e8d316dc59.png',
//             },
//         ),
//         [QualificationFormFieldEnum.COLLABORATING_PHYSICIAN]: PhysicianData.serverToForm({
//             id: 1,
//             state: 'CA',
//             providerId: 4,
//             choice: 3,
//             name: 'uuuu',
//             email: 'evanliu@@q.com',
//             tel: '',
//             address: '',
//             zip: '123',
//             physicianState: 'CB',
//             npi: 'uuuu',
//             yearExp: 0,
//             licenseState: 'CA',
//             specialities: '',
//             effectiveDate: '2023-01-01T00:00:00.000+00:00',
//             expDate: '2023-01-01T00:00:00.000+00:00',
//             url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/1.jpeg',
//         }),
//         [QualificationFormFieldEnum.NURSE_AND_PHYSICIAN_ASSISTANT_LICENSES]: {
//             nurse: LicenseData.serverToForm({
//                 providerId: 23,
//                 type: 'NURSE',
//                 secondType: '1',
//                 state: 'CA',
//                 licenseNumber: '1333',
//                 expireDate: '2022-12-28T00:00:00.000+00:00',
//                 schedule: 'Schedule I',
//                 licenseType: 'AGANCNP-BC:https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/d7226e92-4981-443b-a6c3-b3955dd08c6c.png,abc:https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/0bd327c5-3f4f-41d5-93e2-9e37741fa862.png',
//                 url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/d7226e92-4981-443b-a6c3-b3955dd08c6c.png',
//                 certificatedTitle: 'ctitle',
//                 classTitle: 'classTitle',
//                 hourCompleted: 22,
//             }),
//         },
//         [QualificationFormFieldEnum.CONTROLLED_SUBSTANCE_CERTIFICATION]: LicenseData.serverToForm(
//             {
//                 providerId: 23,
//                 type: 'CSC',
//                 secondType: '1',
//                 state: 'CA',
//                 licenseNumber: '00129108933',
//                 expireDate: '2027-12-02T00:00:00.000+00:00',
//                 schedule: 'Schedule II',
//                 url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/d0744256-bf7e-4fd7-a1e2-5f8344fb2a91.png',
//             },
//         ),
//         [QualificationFormFieldEnum.CONTINUING_MEDICAL_EDUCATION_CERTIFICATES]: {
//             licenses: [
//                 LicenseData.serverToForm({
//                     providerId: 23,
//                     type: 'CMEC',
//                     secondType: '1',
//                     state: 'CA',
//                     licenseNumber: '33313',
//                     url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/4a3cecb0-5b0c-4b4c-96f6-36fbeb44718f.png',
//                 }),
//                 LicenseData.serverToForm({
//                     providerId: 23,
//                     type: 'CMEC',
//                     secondType: '2',
//                     state: 'CA',
//                     licenseNumber: '2221222',
//                     url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/37173b2b-0e68-4db0-9df5-e43c0460cf89.png',
//                 }),
//             ],
//         },
//     },
//     {
//         [QualificationFormFieldEnum.STATE]: 'CB',
//         [QualificationFormFieldEnum.DEA_LICENSES]: LicenseData.serverToForm(
//             {
//                 providerId: 23,
//                 type: 'DEA',
//                 secondType: '1',
//                 state: 'CA',
//                 licenseNumber: '1223456781',
//                 expireDate: '2022-12-17T00:00:00.000+00:00',
//                 schedule: 'Schedule I',
//                 url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/594221b1-a2cf-4a89-9f37-f5e8d316dc59.png',
//             },
//         ),
//         [QualificationFormFieldEnum.COLLABORATING_PHYSICIAN]: PhysicianData.serverToForm({
//             id: 1,
//             state: 'CA',
//             providerId: 4,
//             choice: 1,
//             name: 'uuuu',
//             email: 'evanliu@@q.com',
//             tel: '',
//             address: '',
//             zip: '123',
//             physicianState: 'CB',
//             npi: 'uuuu',
//             yearExp: 0,
//             licenseState: 'CA',
//             specialities: '',
//             effectiveDate: '2023-01-01T00:00:00.000+00:00',
//             expDate: '2023-01-01T00:00:00.000+00:00',
//             url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/1.jpeg',
//         }),
//         [QualificationFormFieldEnum.NURSE_AND_PHYSICIAN_ASSISTANT_LICENSES]: {
//             nurse: LicenseData.serverToForm({
//                 providerId: 23,
//                 type: 'NURSE',
//                 secondType: '1',
//                 state: 'CA',
//                 licenseNumber: '1333',
//                 expireDate: '2022-12-28T00:00:00.000+00:00',
//                 schedule: 'Schedule I',
//                 licenseType: 'AGANCNP-BC:https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/d7226e92-4981-443b-a6c3-b3955dd08c6c.png,abc:https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/0bd327c5-3f4f-41d5-93e2-9e37741fa862.png',
//                 url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/d7226e92-4981-443b-a6c3-b3955dd08c6c.png',
//                 certificatedTitle: 'ctitle',
//                 classTitle: 'classTitle',
//                 hourCompleted: 22,
//             }),
//         },
//         [QualificationFormFieldEnum.CONTROLLED_SUBSTANCE_CERTIFICATION]: LicenseData.serverToForm(
//             {
//                 providerId: 23,
//                 type: 'CSC',
//                 secondType: '1',
//                 state: 'CA',
//                 licenseNumber: '00129108933',
//                 expireDate: '2027-12-02T00:00:00.000+00:00',
//                 schedule: 'Schedule II',
//                 url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/d0744256-bf7e-4fd7-a1e2-5f8344fb2a91.png',
//             },
//         ),
//         [QualificationFormFieldEnum.CONTINUING_MEDICAL_EDUCATION_CERTIFICATES]: {
//             licenses: [
//                 LicenseData.serverToForm({
//                     providerId: 23,
//                     type: 'CMEC',
//                     secondType: '1',
//                     state: 'CA',
//                     licenseNumber: '33313',
//                     url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/4a3cecb0-5b0c-4b4c-96f6-36fbeb44718f.png',
//                 }),
//                 LicenseData.serverToForm({
//                     providerId: 23,
//                     type: 'CMEC',
//                     secondType: '2',
//                     state: 'CA',
//                     licenseNumber: '2221222',
//                     url: 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/37173b2b-0e68-4db0-9df5-e43c0460cf89.png',
//                 }),
//             ],
//         },
//     },
//     ],
// });

export const guiruiData = {
    code: 200,
    message: 'SUCCESS',
    data: [
        {
            start: '2023-01-13T23:00:00.000-07:00',
            end: '2023-01-14T08:00:00.000-07:00',
            providerId: null,
            eventId: 'lnjbph8ng0dlud6r5oqmfrr492_20230114T060000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'DNA',
            timeZone: null,
        },
        {
            start: '2023-01-14T09:00:00.000-07:00',
            end: '2023-01-14T09:30:00.000-07:00',
            providerId: null,
            eventId: 'cub7cvvnaqi1eul4s0keb92qa3_20230114T160000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take calls; dog walk, breakfast prep, commute',
            timeZone: null,
        },
        {
            start: '2023-01-14T16:00:00.000-07:00',
            end: '2023-01-14T16:30:00.000-07:00',
            providerId: null,
            eventId: '2n3nd05pfeprbrm49qb2k4bqv5',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'kiwi insurance',
            timeZone: null,
        },
        {
            start: '2023-01-14T22:00:00.000-07:00',
            end: '2023-01-14T23:00:00.000-07:00',
            providerId: null,
            eventId: '5j7sgrfd01lmgh149s2t5q6ghk_20230115T050000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '5',
            description: null,
            email: ['xujunliu1987@gmail.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Family Time',
            timeZone: null,
        },
        {
            start: '2023-01-14T23:00:00.000-07:00',
            end: '2023-01-15T08:00:00.000-07:00',
            providerId: null,
            eventId: 'lnjbph8ng0dlud6r5oqmfrr492_20230115T060000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'DNA',
            timeZone: null,
        },
        {
            start: '2023-01-15T09:00:00.000-07:00',
            end: '2023-01-15T09:30:00.000-07:00',
            providerId: null,
            eventId: 'cub7cvvnaqi1eul4s0keb92qa3_20230115T160000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take calls; dog walk, breakfast prep, commute',
            timeZone: null,
        },
        {
            start: '2023-01-15T22:00:00.000-07:00',
            end: '2023-01-15T23:00:00.000-07:00',
            providerId: null,
            eventId: '5j7sgrfd01lmgh149s2t5q6ghk_20230116T050000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '5',
            description: null,
            email: ['xujunliu1987@gmail.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Family Time',
            timeZone: null,
        },
        {
            start: '2023-01-15T23:00:00.000-07:00',
            end: '2023-01-16T08:00:00.000-07:00',
            providerId: null,
            eventId: 'lnjbph8ng0dlud6r5oqmfrr492_20230116T060000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'DNA',
            timeZone: null,
        },
        {
            start: '2023-01-16T09:00:00.000-07:00',
            end: '2023-01-16T09:30:00.000-07:00',
            providerId: null,
            eventId: 'cub7cvvnaqi1eul4s0keb92qa3_20230116T160000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take calls; dog walk, breakfast prep, commute',
            timeZone: null,
        },
        {
            start: '2023-01-16T10:00:00.000-07:00',
            end: '2023-01-16T18:00:00.000-07:00',
            providerId: null,
            eventId: '1mj24advid5lfmdo74o17kkbn0',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '3',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Block for all-hand prep',
            timeZone: null,
        },
        {
            start: '2023-01-16T12:30:00.000-07:00',
            end: '2023-01-16T13:00:00.000-07:00',
            providerId: null,
            eventId: '85a2v2ukbs9g065rqkul3fg4du_20230116T190000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['victor.zhou@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Victor / Guorui - Daily Standup',
            timeZone: null,
        },
        {
            start: '2023-01-16T13:00:00.000-07:00',
            end: '2023-01-16T13:30:00.000-07:00',
            providerId: null,
            eventId: '3o5nve0k9drhlnpuk3h4vhgvaq_20230116T200000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'lunch',
            timeZone: null,
        },
        {
            start: '2023-01-16T13:00:00.000-07:00',
            end: '2023-01-16T13:30:00.000-07:00',
            providerId: null,
            eventId: '794i1cs5a28edvigc5o599e65k',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['lillian.ma@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Guorui / Lillian - small 1 on 1 - campaign budgeting by state',
            timeZone: null,
        },
        {
            start: '2023-01-16T18:00:00.000-07:00',
            end: '2023-01-16T18:45:00.000-07:00',
            providerId: null,
            eventId: 'vn4u8qm68a66iaqc9n6s41rsft_20230117T010000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                'Notes:&nbsp;<a href="https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c" style="background-color: var(--textfield-surface);">https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c</a>',
            email: [
                'youming.tang@helloklarity.com',
                'xiaohong.wu@helloklarity.com',
                'catherine.zhang@helloklarity.com',
                'guorui.su@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'BoxPractice Sprint (2/2) - ProviderExperience',
            timeZone: null,
        },
        {
            start: '2023-01-16T19:00:00.000-07:00',
            end: '2023-01-16T19:45:00.000-07:00',
            providerId: null,
            eventId: '7k81p4teackhrbrfcncisjlqn4_20230116T231500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take call & Commute',
            timeZone: null,
        },
        {
            start: '2023-01-16T21:00:00.000-07:00',
            end: '2023-01-16T22:00:00.000-07:00',
            providerId: null,
            eventId: '19cug4otuoqgcjh0h5ds0tq5ds',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: 'guorui.su@helloklarity.com',
            patientPhone: null,
            sendForm: null,
            colorId: '3',
            description: null,
            email: ['guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Focus time: Marketplace PRD',
            timeZone: null,
        },
        {
            start: '2023-01-16T22:00:00.000-07:00',
            end: '2023-01-16T23:00:00.000-07:00',
            providerId: null,
            eventId: '5j7sgrfd01lmgh149s2t5q6ghk_20230117T050000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '5',
            description: null,
            email: ['xujunliu1987@gmail.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Family Time',
            timeZone: null,
        },
        {
            start: '2023-01-16T23:00:00.000-07:00',
            end: '2023-01-17T08:00:00.000-07:00',
            providerId: null,
            eventId: 'lnjbph8ng0dlud6r5oqmfrr492_20230117T060000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'DNA',
            timeZone: null,
        },
        {
            start: '2023-01-17T08:30:00.000-07:00',
            end: '2023-01-17T10:00:00.000-07:00',
            providerId: null,
            eventId: '0p0nkqjoqnmh9t61jdbpas9qr0',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: 'guorui.su@helloklarity.com',
            patientPhone: null,
            sendForm: null,
            colorId: '3',
            description: null,
            email: ['guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Focus time - PRD',
            timeZone: null,
        },
        {
            start: '2023-01-17T09:00:00.000-07:00',
            end: '2023-01-17T09:30:00.000-07:00',
            providerId: null,
            eventId: 'cub7cvvnaqi1eul4s0keb92qa3_20230117T160000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take calls; dog walk, breakfast prep, commute',
            timeZone: null,
        },
        {
            start: '2023-01-17T10:00:00.000-07:00',
            end: '2023-01-17T10:30:00.000-07:00',
            providerId: null,
            eventId: '12hdn6kt8m78iuup67n7h7ku54',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: "doctor's appointment with Dr. Jennifer Rhee",
            timeZone: null,
        },
        {
            start: '2023-01-17T10:30:00.000-07:00',
            end: '2023-01-17T12:00:00.000-07:00',
            providerId: null,
            eventId: '3m57bg5t22gq0hg8s2h3kfegsh',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: 'guorui.su@helloklarity.com',
            patientPhone: null,
            sendForm: null,
            colorId: '3',
            description: null,
            email: ['guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Focus time - project writing',
            timeZone: null,
        },
        {
            start: '2023-01-17T12:00:00.000-07:00',
            end: '2023-01-17T12:30:00.000-07:00',
            providerId: null,
            eventId: 'mfk0ug11qj8h5451d979q90neo_20230116T180000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '4',
            description: null,
            email: ['catherine.zhang@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Catherine/Guorui 1-1',
            timeZone: null,
        },
        {
            start: '2023-01-17T12:30:00.000-07:00',
            end: '2023-01-17T13:15:00.000-07:00',
            providerId: null,
            eventId: '6mnded22oejpriib8o05j465ev_20230116T170000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                "https://us06web.zoom.us/j/84334219650?pwd=ZkNBU2lSbVBqL0NueEo1ejVGeDd4QT09\r\nCatherine, Cecilia - we'll use this slot for a weekly PM/PD sync for BoxPractice. You could meet when I am not present too. ",
            email: [
                'catherine.zhang@helloklarity.com',
                'cecilia.zhao@helloklarity.com',
                'guorui.su@helloklarity.com',
                'aditya.joshi@helloklarity.com',
                'stacey.yao@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'Weekly PM/PD Sync',
            timeZone: null,
        },
        {
            start: '2023-01-17T13:15:00.000-07:00',
            end: '2023-01-17T13:45:00.000-07:00',
            providerId: null,
            eventId: '3o5nve0k9drhlnpuk3h4vhgvaq_20230117T200000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'lunch',
            timeZone: null,
        },
        {
            start: '2023-01-17T15:00:00.000-07:00',
            end: '2023-01-17T16:30:00.000-07:00',
            providerId: null,
            eventId: '46obceo96arug78un7h95vc06g',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['aditya.joshi@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Aditya / Guorui - reserve for marketplace brainstorming',
            timeZone: null,
        },
        {
            start: '2023-01-17T16:30:00.000-07:00',
            end: '2023-01-17T17:00:00.000-07:00',
            providerId: null,
            eventId: '32095h7f6m1arlom9cp78e6j4k',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                'https://us06web.zoom.us/j/83745084194?pwd=Vnk1V1hjTHc5VXBsdFMybURndDRPUT09\r\nInitiative sync',
            email: ['david.queen@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'David / Guorui',
            timeZone: null,
        },
        {
            start: '2023-01-17T17:15:00.000-07:00',
            end: '2023-01-17T17:30:00.000-07:00',
            providerId: null,
            eventId: '5cos1ndh41q3m8fl0na27ih10n',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '5',
            description: null,
            email: ['cecilia.zhao@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Cecilia:Guorui 1-1',
            timeZone: null,
        },
        {
            start: '2023-01-17T17:30:00.000-07:00',
            end: '2023-01-17T18:00:00.000-07:00',
            providerId: null,
            eventId: '3atu6a2t3gd4ltjquere2afe82_20230118T001500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: [
                'xiaocong.liu@helloklarity.com',
                'guorui.su@helloklarity.com',
                'xiaohong.wu@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'R&D manager sync - company initiatives overview',
            timeZone: null,
        },
        {
            start: '2023-01-17T22:00:00.000-07:00',
            end: '2023-01-17T23:00:00.000-07:00',
            providerId: null,
            eventId: '5j7sgrfd01lmgh149s2t5q6ghk_20230118T050000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '5',
            description: null,
            email: ['xujunliu1987@gmail.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Family Time',
            timeZone: null,
        },
        {
            start: '2023-01-17T23:00:00.000-07:00',
            end: '2023-01-18T08:00:00.000-07:00',
            providerId: null,
            eventId: 'lnjbph8ng0dlud6r5oqmfrr492_20230118T060000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'DNA',
            timeZone: null,
        },
        {
            start: '2023-01-18T07:00:00.000-07:00',
            end: '2023-01-18T08:00:00.000-07:00',
            providerId: null,
            eventId: '2dahq63e80cknvest5bnf6qkin_20230118T140000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: [
                'youming.tang@helloklarity.com',
                'xiaohong.wu@helloklarity.com',
                'catherine.zhang@helloklarity.com',
                'cecilia.zhao@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
                'guorui.su@helloklarity.com',
                'jason.shao@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'BoxPractice Dev and Design Connect',
            timeZone: null,
        },
        {
            start: '2023-01-18T08:15:00.000-07:00',
            end: '2023-01-18T09:00:00.000-07:00',
            providerId: null,
            eventId: 's0h331gf0pplirvnam33tocqba_20230117T151500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '4',
            description:
                '<html-blob><u></u><br><u></u><br><u></u>We\'ll use this doc for meeting note:&nbsp;<a href="https://www.notion.so/klarityhealth/Meeting-Notes-65dc7d8d16fb4a4d9ebb18c2c985771a" id="ow684" __is_owner="true">https://www.notion.so/klarityhealth/Meeting-Notes-65dc7d8d16fb4a4d9ebb18c2c985771a</a><br><br><br><u></u>Su Guorui invites you to a meeting on VooV Meeting<br>Meeting Topic: Product Weekly<br>Meeting Time: 2022/09/06 08:00-09:00 (GMT-07:00) Pacific Time - Los Angeles<br>Recurrence: 2022/09/06-2023/09/05 08:00-09:00, Every Tuesday<br><br>Click the link to join the meeting or to add it to your meeting list:<br><a href="https://voovmeeting.com/dm/5j0Pkqqp5QGM">https://voovmeeting.com/dm/5j0Pkqqp5QGM</a><br><br>#VooVMeeting：368-0734-7269<u></u></html-blob>',
            email: [
                'cecilia.zhao@helloklarity.com',
                'guorui.su@helloklarity.com',
                'jason.shao@helloklarity.com',
                'stacey.yao@helloklarity.com',
                'mark.ma@helloklarity.com',
                'kunqian.fan@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
                'aditya.joshi@helloklarity.com',
            ],
            location: 'https://voovmeeting.com/dm/5j0Pkqqp5QGM',
            recurrence: null,
            summary: 'Marketplace Product Weekly / Sprint ',
            timeZone: null,
        },
        {
            start: '2023-01-18T09:00:00.000-07:00',
            end: '2023-01-18T09:45:00.000-07:00',
            providerId: null,
            eventId: 'cub7cvvnaqi1eul4s0keb92qa3_20230118T160000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take calls; dog walk, breakfast prep, commute',
            timeZone: null,
        },
        {
            start: '2023-01-18T10:30:00.000-07:00',
            end: '2023-01-18T11:00:00.000-07:00',
            providerId: null,
            eventId: '6v1rk349mrdm837ovjfn2r6aso',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                '<a href="https://www.notion.so/klarityhealth/Stacey-Guorui-c81c97e710e74cf199a1ac624ec9c9c1">https://www.notion.so/klarityhealth/Stacey-Guorui-c81c97e710e74cf199a1ac624ec9c9c1</a>',
            email: ['stacey.yao@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Stacey:Guorui 1-1',
            timeZone: null,
        },
        {
            start: '2023-01-18T11:00:00.000-07:00',
            end: '2023-01-18T11:30:00.000-07:00',
            providerId: null,
            eventId: 'fk64u34tpeno4uo1f6dk99blag',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                'Event Name: Meeting with Guorui & Victor\n\nLocation: This is a Zoom web conference.\n\nYou can join this meeting from your computer, tablet, or smartphone.\nhttps://us06web.zoom.us/j/89508877124\n\nOne tap mobile:\n+1 646 931 3860,,89508877124#\n+1 929 205 6099,,89508877124#\n\nYou can also dial in using your phone.\nUS: +1 646 931 3860, +1 929 205 6099, +1 301 715 8592, +1 305 224 1968, +1 309 205 3325, +1 312 626 6799, +1 386 347 5053, +1 507 473 4847, +1 564 217 2000, +1 669 444 9171, +1 669 900 6833, +16892781000, +1 719 359 4580, +1 253 205 0468, +1 253 215 8782, +1 346 248 7799, +1 360 209 5623\nMeeting ID: 895-088-77124\n\nFind your local number: https://us06web.zoom.us/u/kdLCuhy6v3\n\nNeed to make changes to this event?\nCancel: https://calendly.com/cancellations/61cc3b85-bdfb-4f05-a076-e6e4f9cb80bf\nReschedule: https://calendly.com/reschedulings/61cc3b85-bdfb-4f05-a076-e6e4f9cb80bf\n\nPowered by Calendly.com\n',
            email: [
                'connor@getoutbounder.com',
                'john@getoutbounder.com',
                'guorui.su@helloklarity.com',
                'victor.zhou@helloklarity.com',
            ],
            location: 'https://us06web.zoom.us/j/89508877124',
            recurrence: null,
            summary: 'Connor Holland and Guorui Su',
            timeZone: null,
        },
        {
            start: '2023-01-18T11:30:00.000-07:00',
            end: '2023-01-18T12:30:00.000-07:00',
            providerId: null,
            eventId: 'd37ak345jqem1fqcm1vfhouigl_20230118T183000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: 'Lillian Ma',
            patientPhone: null,
            sendForm: null,
            colorId: '5',
            description:
                "Hi Lillian,\n\nLong due weekly 1-1. Let's use this cadence to sync product dev progress, analytics progress / insights, marketing insights, team & recruiting, and interdependencies. \n\nGuorui",
            email: ['lillian.ma@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Lillian / Guorui 1-1 (weekly in-depth)',
            timeZone: null,
        },
        {
            start: '2023-01-18T13:00:00.000-07:00',
            end: '2023-01-18T13:30:00.000-07:00',
            providerId: null,
            eventId: '3o5nve0k9drhlnpuk3h4vhgvaq_20230118T200000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'lunch',
            timeZone: null,
        },
        {
            start: '2023-01-18T14:00:00.000-07:00',
            end: '2023-01-18T15:30:00.000-07:00',
            providerId: null,
            eventId: '60jbh3ch597m5m4tgo3f4ug508',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['aditya.joshi@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Reserve for BI & Analytics Roadmap',
            timeZone: null,
        },
        {
            start: '2023-01-18T15:30:00.000-07:00',
            end: '2023-01-18T16:00:00.000-07:00',
            providerId: null,
            eventId: '5a9iq09lcvgte46pckptjhc85e',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['aditya.joshi@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Boxpractice walkthrough',
            timeZone: null,
        },
        {
            start: '2023-01-18T17:00:00.000-07:00',
            end: '2023-01-18T18:00:00.000-07:00',
            providerId: null,
            eventId: '0p202lcatkgifas9s32ohrdlcb',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['david.queen@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'David / Guorui - Projects write-up sync',
            timeZone: null,
        },
        {
            start: '2023-01-18T18:00:00.000-07:00',
            end: '2023-01-18T18:45:00.000-07:00',
            providerId: null,
            eventId: 'ff1f11k3rs35pdkcn571jm95on_20230118T010000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '4',
            description:
                'Co-working on product, tech, and design roadmap for our BoxPractice (SaaS Product)<br><br>Ongoing Meeting Notes: <a href="https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c">https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c</a><br><br>Guorui Su is inviting you to a scheduled Zoom meeting.<br><br><br>Join Zoom Meeting<br><a href="https://us06web.zoom.us/j/87578773699"><u>https://us06web.zoom.us/j/87578773699</u></a>',
            email: [
                'xiaohong.wu@helloklarity.com',
                'catherine.zhang@helloklarity.com',
                'guorui.su@helloklarity.com',
                'cecilia.zhao@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
                'kunqian.fan@helloklarity.com',
                'zhengkai.zou@helloklarity.com',
                'jason.shao@helloklarity.com',
            ],
            location: 'https://us06web.zoom.us/j/87578773699',
            recurrence: null,
            summary: 'BoxPractice Sprint (1/2)- Channels / PF / PPP',
            timeZone: null,
        },
        {
            start: '2023-01-18T19:00:00.000-07:00',
            end: '2023-01-18T19:45:00.000-07:00',
            providerId: null,
            eventId: '7k81p4teackhrbrfcncisjlqn4_20230118T231500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take call & Commute',
            timeZone: null,
        },
        {
            start: '2023-01-18T21:00:00.000-07:00',
            end: '2023-01-18T22:00:00.000-07:00',
            providerId: null,
            eventId: '2et6cpjqhqfgqv57uneluridle',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'QA',
            timeZone: null,
        },
        {
            start: '2023-01-18T22:00:00.000-07:00',
            end: '2023-01-18T23:00:00.000-07:00',
            providerId: null,
            eventId: '5j7sgrfd01lmgh149s2t5q6ghk_20230119T050000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '5',
            description: null,
            email: ['xujunliu1987@gmail.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Family Time',
            timeZone: null,
        },
        {
            start: '2023-01-18T23:00:00.000-07:00',
            end: '2023-01-19T08:00:00.000-07:00',
            providerId: null,
            eventId: 'lnjbph8ng0dlud6r5oqmfrr492_20230119T060000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'DNA',
            timeZone: null,
        },
        {
            start: '2023-01-19T09:00:00.000-07:00',
            end: '2023-01-19T09:45:00.000-07:00',
            providerId: null,
            eventId: 'cub7cvvnaqi1eul4s0keb92qa3_20230119T160000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take calls; dog walk, breakfast prep, commute',
            timeZone: null,
        },
        {
            start: '2023-01-19T09:30:00.000-07:00',
            end: '2023-01-19T10:00:00.000-07:00',
            providerId: null,
            eventId: 'hm9kurp79arr53q9ctk603eca4',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                'Event Name: 30min with Guorui\n\nLocation: This is a Zoom web conference.\n\nYou can join this meeting from your computer, tablet, or smartphone.\nhttps://us06web.zoom.us/j/87416814151\n\nOne tap mobile:\n+1 929 205 6099,,87416814151#\n+1 301 715 8592,,87416814151#\n\nYou can also dial in using your phone.\nUS: +1 929 205 6099, +1 301 715 8592, +1 305 224 1968, +1 309 205 3325, +1 312 626 6799, +1 646 931 3860, +1 386 347 5053, +1 507 473 4847, +1 564 217 2000, +1 669 444 9171, +1 669 900 6833, +16892781000, +1 719 359 4580, +1 253 205 0468, +1 253 215 8782, +1 346 248 7799, +1 360 209 5623\nMeeting ID: 874-168-14151\n\nFind your local number: https://us06web.zoom.us/u/kdxdqYMpdH\n\nPlease share anything that will help prepare for our meeting.: Consulting project follow up\n\nNeed to make changes to this event?\nCancel: https://calendly.com/cancellations/ce2d697e-729f-4aea-8bc5-6877de1debec\nReschedule: https://calendly.com/reschedulings/ce2d697e-729f-4aea-8bc5-6877de1debec\n\nPowered by Calendly.com\n',
            email: ['kelseyding0506@gmail.com', 'guorui.su@helloklarity.com'],
            location: 'https://us06web.zoom.us/j/87416814151',
            recurrence: null,
            summary: 'Kelsey Ding and Guorui Su',
            timeZone: null,
        },
        {
            start: '2023-01-19T12:00:00.000-07:00',
            end: '2023-01-19T12:30:00.000-07:00',
            providerId: null,
            eventId: '85a2v2ukbs9g065rqkul3fg4du_20230119T190000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['victor.zhou@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Victor / Guorui - Daily Standup',
            timeZone: null,
        },
        {
            start: '2023-01-19T13:00:00.000-07:00',
            end: '2023-01-19T13:30:00.000-07:00',
            providerId: null,
            eventId: '3o5nve0k9drhlnpuk3h4vhgvaq_20230119T200000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'lunch',
            timeZone: null,
        },
        {
            start: '2023-01-19T15:00:00.000-07:00',
            end: '2023-01-19T15:45:00.000-07:00',
            providerId: null,
            eventId: 'mfk0ug11qj8h5451d979q90neo_20230119T180000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '4',
            description: null,
            email: ['catherine.zhang@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Catherine/Guorui 1-1',
            timeZone: null,
        },
        {
            start: '2023-01-19T22:00:00.000-07:00',
            end: '2023-01-19T23:00:00.000-07:00',
            providerId: null,
            eventId: '5j7sgrfd01lmgh149s2t5q6ghk_20230120T050000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '5',
            description: null,
            email: ['xujunliu1987@gmail.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Family Time',
            timeZone: null,
        },
        {
            start: '2023-01-19T23:00:00.000-07:00',
            end: '2023-01-20T08:00:00.000-07:00',
            providerId: null,
            eventId: 'lnjbph8ng0dlud6r5oqmfrr492_20230120T060000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'DNA',
            timeZone: null,
        },
        {
            start: '2023-01-20T08:00:00.000-07:00',
            end: '2023-01-20T08:45:00.000-07:00',
            providerId: null,
            eventId: 'cub7cvvnaqi1eul4s0keb92qa3_20230120T160000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take calls; dog walk, breakfast prep, commute',
            timeZone: null,
        },
        {
            start: '2023-01-20T10:00:00.000-07:00',
            end: '2023-01-20T10:30:00.000-07:00',
            providerId: null,
            eventId: '6qf9d41ig6198ho70urr06f140',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: 'Cecilia Zhao',
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                'As discuss today, I aim to clear major unknowns to unblock design work for marketplace',
            email: [
                'aditya.joshi@helloklarity.com',
                'cecilia.zhao@helloklarity.com',
                'guorui.su@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'Hold for new marketplace PM/PD sync',
            timeZone: null,
        },
        {
            start: '2023-01-20T11:00:00.000-07:00',
            end: '2023-01-20T11:30:00.000-07:00',
            providerId: null,
            eventId: '68lcjpo61v3je6t729ovdr760d_20230120T180000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: 'Lillian Ma',
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['lillian.ma@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Lillian / Guorui - In-person catch-up',
            timeZone: null,
        },
        {
            start: '2023-01-20T11:30:00.000-07:00',
            end: '2023-01-20T12:00:00.000-07:00',
            providerId: null,
            eventId: '24so5s00hrmuf50b8s06djh4rc',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                'https://us06web.zoom.us/j/83065970883?pwd=ak9zajB3UHNZTVlHZm84MXN4OFhzZz09\r\n',
            email: [
                'mark.ma@helloklarity.com',
                'lillian.ma@helloklarity.com',
                'david.queen@helloklarity.com',
                'aditya.joshi@helloklarity.com',
                'guorui.su@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: '[Hold] Marketplace Ops Program Sync',
            timeZone: null,
        },
        {
            start: '2023-01-20T12:00:00.000-07:00',
            end: '2023-01-20T12:30:00.000-07:00',
            providerId: null,
            eventId: '1obblk34295tgq02o3e457pa83',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: 'Lillian Ma',
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                'Placeholder for meeting to align on Roles & Responsibilities re: marketplaces going forward',
            email: [
                'lillian.ma@helloklarity.com',
                'david.queen@helloklarity.com',
                'aditya.joshi@helloklarity.com',
                'guorui.su@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'Marketplace PM/Marketing/Ops metrics and R&D sync',
            timeZone: null,
        },
        {
            start: '2023-01-20T12:30:00.000-07:00',
            end: '2023-01-20T13:00:00.000-07:00',
            providerId: null,
            eventId: '4utkn24rmegpi0oovrbm04ioqv',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['aditya.joshi@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'quick chat on things to be covered when im out',
            timeZone: null,
        },
        {
            start: '2023-01-20T13:00:00.000-07:00',
            end: '2023-01-20T13:30:00.000-07:00',
            providerId: null,
            eventId: '3o5nve0k9drhlnpuk3h4vhgvaq_20230120T200000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'lunch',
            timeZone: null,
        },
        {
            start: '2023-01-20T15:00:00.000-07:00',
            end: '2023-01-20T15:30:00.000-07:00',
            providerId: null,
            eventId: '97erk8rc22lh0e1sve5bkg26qs',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                'Event Name: 30min with Guorui\n\nLocation: This is a Zoom web conference.\n\nYou can join this meeting from your computer, tablet, or smartphone.\nhttps://us06web.zoom.us/j/89042429279\n\nOne tap mobile:\n+1 305 224 1968,,89042429279#\n+1 309 205 3325,,89042429279#\n\nYou can also dial in using your phone.\nUS: +1 305 224 1968, +1 309 205 3325, +1 312 626 6799, +1 646 931 3860, +1 929 205 6099, +1 301 715 8592, +1 719 359 4580, +1 253 205 0468, +1 253 215 8782, +1 346 248 7799, +1 360 209 5623, +1 386 347 5053, +1 507 473 4847, +1 564 217 2000, +1 669 444 9171, +1 669 900 6833, +16892781000\nMeeting ID: 890-424-29279\n\nFind your local number: https://us06web.zoom.us/u/kVs93AxCI\n\nNeed to make changes to this event?\nCancel: https://calendly.com/cancellations/35c2c4f5-4bf2-4127-b5c2-02c7627a8c95\nReschedule: https://calendly.com/reschedulings/35c2c4f5-4bf2-4127-b5c2-02c7627a8c95\n\nPowered by Calendly.com\n',
            email: [
                'guorui.su@helloklarity.com',
                'shirleyy.wang@eastwestbank.com',
                'victor.zhou@helloklarity.com',
            ],
            location: 'https://us06web.zoom.us/j/89042429279',
            recurrence: null,
            summary: 'Shirley Y. Wang and Guorui Su',
            timeZone: null,
        },
        {
            start: '2023-01-20T17:00:00.000-07:00',
            end: '2023-01-20T17:45:00.000-07:00',
            providerId: null,
            eventId: '7k81p4teackhrbrfcncisjlqn4_20230120T231500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take call & Commute',
            timeZone: null,
        },
        {
            start: '2023-01-20T18:00:00.000-07:00',
            end: '2023-01-20T18:45:00.000-07:00',
            providerId: null,
            eventId: 'sfab28g6ktope7mj41mcu6noq5_20230120T223000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: 'guorui.su@helloklarity.com',
            patientPhone: null,
            sendForm: null,
            colorId: '3',
            description: null,
            email: ['guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Focus time - weekly summary',
            timeZone: null,
        },
        {
            start: '2023-01-20T19:00:00.000-07:00',
            end: '2023-01-20T19:45:00.000-07:00',
            providerId: null,
            eventId: '6ubnb3muneto15hm5jhqotmg5r',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: '401k -> robinhood',
            timeZone: null,
        },
        {
            start: '2023-01-20T22:00:00.000-07:00',
            end: '2023-01-20T23:00:00.000-07:00',
            providerId: null,
            eventId: '5j7sgrfd01lmgh149s2t5q6ghk_20230121T050000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '5',
            description: null,
            email: ['xujunliu1987@gmail.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Family Time',
            timeZone: null,
        },
        {
            start: '2023-01-20T23:00:00.000-07:00',
            end: '2023-01-21T08:00:00.000-07:00',
            providerId: null,
            eventId: 'lnjbph8ng0dlud6r5oqmfrr492_20230121T060000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'DNA',
            timeZone: null,
        },
        {
            start: '2023-01-21T09:00:00.000-07:00',
            end: '2023-01-21T09:45:00.000-07:00',
            providerId: null,
            eventId: 'cub7cvvnaqi1eul4s0keb92qa3_20230121T160000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take calls; dog walk, breakfast prep, commute',
            timeZone: null,
        },
        {
            start: '2023-01-21T22:00:00.000-07:00',
            end: '2023-01-21T23:00:00.000-07:00',
            providerId: null,
            eventId: '5j7sgrfd01lmgh149s2t5q6ghk_20230122T050000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '5',
            description: null,
            email: ['xujunliu1987@gmail.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Family Time',
            timeZone: null,
        },
        {
            start: '2023-01-21T23:00:00.000-07:00',
            end: '2023-01-22T08:00:00.000-07:00',
            providerId: null,
            eventId: 'lnjbph8ng0dlud6r5oqmfrr492_20230122T060000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'DNA',
            timeZone: null,
        },
        {
            start: '2023-01-22T09:00:00.000-07:00',
            end: '2023-01-22T09:45:00.000-07:00',
            providerId: null,
            eventId: 'cub7cvvnaqi1eul4s0keb92qa3_20230122T160000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take calls; dog walk, breakfast prep, commute',
            timeZone: null,
        },
        {
            start: '2023-01-22T22:00:00.000-07:00',
            end: '2023-01-22T23:00:00.000-07:00',
            providerId: null,
            eventId: '5j7sgrfd01lmgh149s2t5q6ghk_20230123T050000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '5',
            description: null,
            email: ['xujunliu1987@gmail.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Family Time',
            timeZone: null,
        },
        {
            start: '2023-01-22T23:00:00.000-07:00',
            end: '2023-01-23T08:00:00.000-07:00',
            providerId: null,
            eventId: 'lnjbph8ng0dlud6r5oqmfrr492_20230123T060000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'DNA',
            timeZone: null,
        },
        {
            start: '2023-01-22T17:00:00.000-07:00',
            end: '2023-02-03T17:00:00.000-07:00',
            providerId: null,
            eventId: '4c73rauiagv9uhpd4dlee1gr1o',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'AJ in India',
            timeZone: null,
        },
        {
            start: '2023-01-23T09:00:00.000-07:00',
            end: '2023-01-23T09:45:00.000-07:00',
            providerId: null,
            eventId: 'cub7cvvnaqi1eul4s0keb92qa3_20230123T160000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take calls; dog walk, breakfast prep, commute',
            timeZone: null,
        },
        {
            start: '2023-01-23T09:15:00.000-07:00',
            end: '2023-01-23T10:00:00.000-07:00',
            providerId: null,
            eventId: 't572q84m7kp1umulhiult3dc5r_20230123T161500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: 'guorui.su@helloklarity.com',
            patientPhone: null,
            sendForm: null,
            colorId: '3',
            description: null,
            email: ['guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Focus time - Backlog Review & Product Brief ',
            timeZone: null,
        },
        {
            start: '2023-01-23T12:00:00.000-07:00',
            end: '2023-01-23T12:30:00.000-07:00',
            providerId: null,
            eventId: '85a2v2ukbs9g065rqkul3fg4du_20230123T190000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['victor.zhou@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Victor / Guorui - Daily Standup',
            timeZone: null,
        },
        {
            start: '2023-01-23T13:00:00.000-07:00',
            end: '2023-01-23T13:30:00.000-07:00',
            providerId: null,
            eventId: '3o5nve0k9drhlnpuk3h4vhgvaq_20230123T200000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'lunch',
            timeZone: null,
        },
        {
            start: '2023-01-23T15:25:00.000-07:00',
            end: '2023-01-23T15:40:00.000-07:00',
            providerId: null,
            eventId: '1q4u0al0kijuh9mka668asq60m',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['mark.ma@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Going through rotation algo example',
            timeZone: null,
        },
        {
            start: '2023-01-23T16:45:00.000-07:00',
            end: '2023-01-23T17:30:00.000-07:00',
            providerId: null,
            eventId: '7k81p4teackhrbrfcncisjlqn4_20230123T231500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take call & Commute',
            timeZone: null,
        },
        {
            start: '2023-01-23T17:30:00.000-07:00',
            end: '2023-01-23T18:30:00.000-07:00',
            providerId: null,
            eventId: '066bfqvuji7un44v8h2i3q1uv8',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['david.queen@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary:
                'David / Guorui - hold for various topics related to provider leadgen, onboarding ,etc.',
            timeZone: null,
        },
        {
            start: '2023-01-23T22:00:00.000-07:00',
            end: '2023-01-23T23:00:00.000-07:00',
            providerId: null,
            eventId: '5j7sgrfd01lmgh149s2t5q6ghk_20230124T050000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '5',
            description: null,
            email: ['xujunliu1987@gmail.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Family Time',
            timeZone: null,
        },
        {
            start: '2023-01-23T23:00:00.000-07:00',
            end: '2023-01-24T08:00:00.000-07:00',
            providerId: null,
            eventId: 'lnjbph8ng0dlud6r5oqmfrr492_20230124T060000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'DNA',
            timeZone: null,
        },
        {
            start: '2023-01-24T08:45:00.000-07:00',
            end: '2023-01-24T09:30:00.000-07:00',
            providerId: null,
            eventId: 'cub7cvvnaqi1eul4s0keb92qa3_20230124T160000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take calls; dog walk, breakfast prep, commute',
            timeZone: null,
        },
        {
            start: '2023-01-24T09:30:00.000-07:00',
            end: '2023-01-24T10:00:00.000-07:00',
            providerId: null,
            eventId: 'mfk0ug11qj8h5451d979q90neo_20230123T180000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '4',
            description: null,
            email: ['catherine.zhang@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Catherine/Guorui 1-1',
            timeZone: null,
        },
        {
            start: '2023-01-24T10:00:00.000-07:00',
            end: '2023-01-24T17:00:00.000-07:00',
            providerId: null,
            eventId: '1l1hvk0301p7agvr486hcit9gt_20230124T170000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: 'guorui.su@helloklarity.com',
            patientPhone: null,
            sendForm: null,
            colorId: '3',
            description: null,
            email: ['guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Do Not Schedule - Focus time for Deep Work',
            timeZone: null,
        },
        {
            start: '2023-01-24T12:00:00.000-07:00',
            end: '2023-01-24T12:30:00.000-07:00',
            providerId: null,
            eventId: '85a2v2ukbs9g065rqkul3fg4du_20230124T190000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['victor.zhou@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Victor / Guorui - Daily Standup',
            timeZone: null,
        },
        {
            start: '2023-01-24T13:00:00.000-07:00',
            end: '2023-01-24T13:30:00.000-07:00',
            providerId: null,
            eventId: '3o5nve0k9drhlnpuk3h4vhgvaq_20230124T200000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'lunch',
            timeZone: null,
        },
        {
            start: '2023-01-24T17:00:00.000-07:00',
            end: '2023-01-24T17:45:00.000-07:00',
            providerId: null,
            eventId: 'd5f5k99h2moknqe3o6cljfeoqb_20230128T000000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '4',
            description:
                '<html-blob><u></u><u></u>Hi Cecilia,<br><br>In addition to our 1-hr work review (focus on projects) each Monday, I also want to have a weekly 30min 1-1 on tactical such as interviews, company updates, etc. Let me know if this slot doesn\'t work. You have edit access so feel free to adjust the time.<br><br>Guorui<u></u><br><u></u><a href="https://www.notion.so/klarityhealth/Cecilia-Guorui-4eeb8f0ceaf2488085a1e84ae56e3efa" id="ow751" __is_owner="true">Note</a><u></u><u></u><br>──────────<br><br>Guorui Su is inviting you to a scheduled Zoom meeting.<br><br>Join Zoom Meeting<br><a href="https://us06web.zoom.us/j/87581969598?pwd=WTE2M21lTXJhK08vVmd0OUVwTGFvdz09">https://us06web.zoom.us/j/87581969598?pwd=WTE2M21lTXJhK08vVmd0OUVwTGFvdz09</a><br><br>Meeting ID: 875 8196 9598<br>Passcode: 571i52<br><br><br><br>──────────</html-blob>',
            email: ['cecilia.zhao@boxpractice.com', 'guorui.su@helloklarity.com'],
            location:
                'https://us06web.zoom.us/j/87581969598?pwd=WTE2M21lTXJhK08vVmd0OUVwTGFvdz09',
            recurrence: null,
            summary: 'Guorui/Cecilia biweekly 1-1',
            timeZone: null,
        },
        {
            start: '2023-01-24T22:00:00.000-07:00',
            end: '2023-01-24T23:00:00.000-07:00',
            providerId: null,
            eventId: '5j7sgrfd01lmgh149s2t5q6ghk_20230125T050000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '5',
            description: null,
            email: ['xujunliu1987@gmail.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Family Time',
            timeZone: null,
        },
        {
            start: '2023-01-24T23:00:00.000-07:00',
            end: '2023-01-25T08:00:00.000-07:00',
            providerId: null,
            eventId: 'lnjbph8ng0dlud6r5oqmfrr492_20230125T060000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'DNA',
            timeZone: null,
        },
        {
            start: '2023-01-25T08:30:00.000-07:00',
            end: '2023-01-25T09:00:00.000-07:00',
            providerId: null,
            eventId: 'b6p4gvrl79mfciivf3sppuifld_20230125T153000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '4',
            description:
                '<html-blob><u></u>Su Guorui invites you to a meeting on VooV Meeting<br>Meeting Topic: Product Org Meeting<br>Meeting Time: 2022/09/01 08:00-09:00 (GMT-07:00) Pacific Time - Los Angeles<br>Recurrence: 2022/09/01-2023/01/12 08:00-09:00, Every Thursday<br><br>Click the link to join the meeting or to add it to your meeting list:<br><a href="https://voovmeeting.com/dm/ucVjEEJg3alf">https://voovmeeting.com/dm/ucVjEEJg3alf</a><br><br>#VooVMeeting：459-0362-9804<u></u></html-blob><br><html-blob><a href="https://www.notion.so/klarityhealth/Klarity-Marketplace-ed83904a19374486af3be4804add0791" id="ow6198" __is_owner="true">Meeting Meeting Agenda</a></html-blob>',
            email: ['jason.shao@boxpractice.com', 'guorui.su@helloklarity.com'],
            location: 'https://voovmeeting.com/dm/ucVjEEJg3alf',
            recurrence: null,
            summary: 'Jason/Guorui - every other week',
            timeZone: null,
        },
        {
            start: '2023-01-25T09:00:00.000-07:00',
            end: '2023-01-25T09:45:00.000-07:00',
            providerId: null,
            eventId: 'cub7cvvnaqi1eul4s0keb92qa3_20230125T160000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take calls; dog walk, breakfast prep, commute',
            timeZone: null,
        },
        {
            start: '2023-01-25T09:15:00.000-07:00',
            end: '2023-01-25T10:00:00.000-07:00',
            providerId: null,
            eventId: 't572q84m7kp1umulhiult3dc5r_20230125T161500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: 'guorui.su@helloklarity.com',
            patientPhone: null,
            sendForm: null,
            colorId: '3',
            description: null,
            email: ['guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Focus time - Backlog Review & Product Brief ',
            timeZone: null,
        },
        {
            start: '2023-01-25T10:00:00.000-07:00',
            end: '2023-01-25T11:00:00.000-07:00',
            providerId: null,
            eventId: '1187enbpe5pm5ds788ill673mp_20230125T170000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['victor.zhou@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: '[In person] Guorui / Victor - Operation & Marketplace',
            timeZone: null,
        },
        {
            start: '2023-01-25T11:30:00.000-07:00',
            end: '2023-01-25T12:30:00.000-07:00',
            providerId: null,
            eventId: 'd37ak345jqem1fqcm1vfhouigl_20230125T183000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: 'Lillian Ma',
            patientPhone: null,
            sendForm: null,
            colorId: '5',
            description:
                "Hi Lillian,\n\nLong due weekly 1-1. Let's use this cadence to sync product dev progress, analytics progress / insights, marketing insights, team & recruiting, and interdependencies. \n\nGuorui",
            email: ['lillian.ma@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Lillian / Guorui 1-1 (weekly in-depth)',
            timeZone: null,
        },
        {
            start: '2023-01-25T13:00:00.000-07:00',
            end: '2023-01-25T13:30:00.000-07:00',
            providerId: null,
            eventId: '3o5nve0k9drhlnpuk3h4vhgvaq_20230125T200000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'lunch',
            timeZone: null,
        },
        {
            start: '2023-01-25T13:00:00.000-07:00',
            end: '2023-01-25T14:00:00.000-07:00',
            providerId: null,
            eventId: '59egadasq3d1u3bpue3bdguqvl',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: [
                'victor.zhou@helloklarity.com',
                'sugar.rui.wang@gmail.com',
                'lillian.ma@helloklarity.com',
                'guorui.su@helloklarity.com',
            ],
            location: '370 Convention Way, Redwood City, CA 94063, USA',
            recurrence: null,
            summary: 'Lunch - Ray/Guorui/Lillian/Victor',
            timeZone: null,
        },
        {
            start: '2023-01-25T16:15:00.000-07:00',
            end: '2023-01-25T17:00:00.000-07:00',
            providerId: null,
            eventId: '7k81p4teackhrbrfcncisjlqn4_20230125T231500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take call & Commute',
            timeZone: null,
        },
        {
            start: '2023-01-25T22:00:00.000-07:00',
            end: '2023-01-25T23:00:00.000-07:00',
            providerId: null,
            eventId: '5j7sgrfd01lmgh149s2t5q6ghk_20230126T050000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '5',
            description: null,
            email: ['xujunliu1987@gmail.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Family Time',
            timeZone: null,
        },
        {
            start: '2023-01-25T23:00:00.000-07:00',
            end: '2023-01-26T08:00:00.000-07:00',
            providerId: null,
            eventId: 'lnjbph8ng0dlud6r5oqmfrr492_20230126T060000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'DNA',
            timeZone: null,
        },
        {
            start: '2023-01-26T09:00:00.000-07:00',
            end: '2023-01-26T10:00:00.000-07:00',
            providerId: null,
            eventId: '6mnded22oejpriib8o05j465ev_20230123T170000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: '<ul><li>Ops Portal Design Review</li></ul>',
            email: [
                'catherine.zhang@helloklarity.com',
                'cecilia.zhao@helloklarity.com',
                'guorui.su@helloklarity.com',
                'aditya.joshi@helloklarity.com',
                'stacey.yao@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'Weekly PM/PD Sync',
            timeZone: null,
        },
        {
            start: '2023-01-26T09:00:00.000-07:00',
            end: '2023-01-26T09:45:00.000-07:00',
            providerId: null,
            eventId: 'cub7cvvnaqi1eul4s0keb92qa3_20230126T160000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take calls; dog walk, breakfast prep, commute',
            timeZone: null,
        },
        {
            start: '2023-01-26T10:00:00.000-07:00',
            end: '2023-01-26T10:30:00.000-07:00',
            providerId: null,
            eventId: 'nhvoi4qbl97h7453js0da51q5g',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                'Event Name: 30min with Guorui\n\nLocation: This is a Zoom web conference.\n\nYou can join this meeting from your computer, tablet, or smartphone.\nhttps://us06web.zoom.us/j/82991304914\n\nOne tap mobile:\n+1 646 931 3860,,82991304914#\n+1 929 205 6099,,82991304914#\n\nYou can also dial in using your phone.\nUS: +1 646 931 3860, +1 929 205 6099, +1 301 715 8592, +1 305 224 1968, +1 309 205 3325, +1 312 626 6799, +1 719 359 4580, +1 253 205 0468, +1 253 215 8782, +1 346 248 7799, +1 360 209 5623, +1 386 347 5053, +1 507 473 4847, +1 564 217 2000, +1 669 444 9171, +1 669 900 6833, +16892781000\nMeeting ID: 829-913-04914\n\nFind your local number: https://us06web.zoom.us/u/kdzyr80YH\n\nNeed to make changes to this event?\nCancel: https://calendly.com/cancellations/6bdfc49f-5f11-45a1-adcb-dc12402fc676\nReschedule: https://calendly.com/reschedulings/6bdfc49f-5f11-45a1-adcb-dc12402fc676\n\nPowered by Calendly.com\n',
            email: ['racheleleroy@gmail.com', 'guorui.su@helloklarity.com'],
            location: 'https://us06web.zoom.us/j/82991304914',
            recurrence: null,
            summary: 'Rachel LeRoy and Guorui Su',
            timeZone: null,
        },
        {
            start: '2023-01-26T10:30:00.000-07:00',
            end: '2023-01-26T12:00:00.000-07:00',
            providerId: null,
            eventId: '0falgj43pbmo7i56und1gs5hq2',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: 'guorui.su@helloklarity.com',
            patientPhone: null,
            sendForm: null,
            colorId: '3',
            description: null,
            email: ['guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Focus time - ops portal',
            timeZone: null,
        },
        {
            start: '2023-01-26T13:00:00.000-07:00',
            end: '2023-01-26T13:30:00.000-07:00',
            providerId: null,
            eventId: '3o5nve0k9drhlnpuk3h4vhgvaq_20230126T200000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'lunch',
            timeZone: null,
        },
        {
            start: '2023-01-26T15:30:00.000-07:00',
            end: '2023-01-26T16:15:00.000-07:00',
            providerId: null,
            eventId: 'mfk0ug11qj8h5451d979q90neo_20230126T180000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '4',
            description: '- Ops Portal Review',
            email: ['catherine.zhang@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Catherine/Guorui 1-1',
            timeZone: null,
        },
        {
            start: '2023-01-26T16:15:00.000-07:00',
            end: '2023-01-26T17:00:00.000-07:00',
            providerId: null,
            eventId: '2lbqj82flbh8lvh3395up5jv97',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: 'guorui.su@helloklarity.com',
            patientPhone: null,
            sendForm: null,
            colorId: '3',
            description: null,
            email: ['guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Focus time: marketing email',
            timeZone: null,
        },
        {
            start: '2023-01-26T17:00:00.000-07:00',
            end: '2023-01-26T18:00:00.000-07:00',
            providerId: null,
            eventId: '2nfb95i8b33c6cmq6kkadv5lk3',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: 'guorui.su@helloklarity.com',
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Out of office',
            timeZone: null,
        },
        {
            start: '2023-01-26T18:00:00.000-07:00',
            end: '2023-01-26T21:00:00.000-07:00',
            providerId: null,
            eventId: 'mp9042v3v4eki8qer438j8desg',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: 'Rich Table, 199 Gough St, San Francisco, CA 94102, USA',
            recurrence: null,
            summary: 'Dinner',
            timeZone: null,
        },
        {
            start: '2023-01-26T22:00:00.000-07:00',
            end: '2023-01-26T23:00:00.000-07:00',
            providerId: null,
            eventId: '5j7sgrfd01lmgh149s2t5q6ghk_20230127T050000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '5',
            description: null,
            email: ['xujunliu1987@gmail.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Family Time',
            timeZone: null,
        },
        {
            start: '2023-01-26T23:00:00.000-07:00',
            end: '2023-01-27T08:00:00.000-07:00',
            providerId: null,
            eventId: 'lnjbph8ng0dlud6r5oqmfrr492_20230127T060000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'DNA',
            timeZone: null,
        },
        {
            start: '2023-01-27T09:00:00.000-07:00',
            end: '2023-01-27T09:45:00.000-07:00',
            providerId: null,
            eventId: 'cub7cvvnaqi1eul4s0keb92qa3_20230127T160000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take calls; dog walk, breakfast prep, commute',
            timeZone: null,
        },
        {
            start: '2023-01-27T09:15:00.000-07:00',
            end: '2023-01-27T09:45:00.000-07:00',
            providerId: null,
            eventId: '3g7asmjblli3ldf2ul0vlmo9fk',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Hold for Brix call',
            timeZone: null,
        },
        {
            start: '2023-01-27T10:00:00.000-07:00',
            end: '2023-01-27T11:00:00.000-07:00',
            providerId: null,
            eventId: '0gkbqptmvh25ovt8v7ckj9r796',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['guorui.su@helloklarity.com', 'victor.zhou@helloklarity.com'],
            location: null,
            recurrence: null,
            summary:
                'Victor / Guorui - Sync on the location expansion plan for new marketplace',
            timeZone: null,
        },
        {
            start: '2023-01-27T10:00:00.000-07:00',
            end: '2023-01-27T10:30:00.000-07:00',
            providerId: null,
            eventId: 'cnkhgq5956nosvvpe6rtg89kk5_20230127T170000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: [
                'clara.k@klarityadhd.com',
                'guorui.su@helloklarity.com',
                'cecilia.zhao@helloklarity.com',
                'catherine.zhang@helloklarity.com',
                'aditya.joshi@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'CS/Product Bi-weekly catchup',
            timeZone: null,
        },
        {
            start: '2023-01-27T12:00:00.000-07:00',
            end: '2023-01-27T13:30:00.000-07:00',
            providerId: null,
            eventId: '7d5tq1uug5na6mgah9rq4b4sl4_20230127T170000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['victor.zhou@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary:
                '[In-person] Victor / Guorui - Pilot vs R&D (non-marketplace related)',
            timeZone: null,
        },
        {
            start: '2023-01-27T13:00:00.000-07:00',
            end: '2023-01-27T13:30:00.000-07:00',
            providerId: null,
            eventId: '3o5nve0k9drhlnpuk3h4vhgvaq_20230127T200000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'lunch',
            timeZone: null,
        },
        {
            start: '2023-01-27T13:45:00.000-07:00',
            end: '2023-01-27T14:00:00.000-07:00',
            providerId: null,
            eventId: '0birocpphnecdn3fredc3ga7a9',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['mark.ma@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'SupplyDemandOperations',
            timeZone: null,
        },
        {
            start: '2023-01-27T14:00:00.000-07:00',
            end: '2023-01-27T15:30:00.000-07:00',
            providerId: null,
            eventId: '5t0dk1dph7t6cr8cfmtbb0qkg1',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['victor.zhou@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: '[In person] Guorui / Victor - Company Management Lineup',
            timeZone: null,
        },
        {
            start: '2023-01-27T15:30:00.000-07:00',
            end: '2023-01-27T16:15:00.000-07:00',
            providerId: null,
            eventId: 'sfab28g6ktope7mj41mcu6noq5_20230127T223000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: 'guorui.su@helloklarity.com',
            patientPhone: null,
            sendForm: null,
            colorId: '3',
            description: null,
            email: ['guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Focus time - weekly summary',
            timeZone: null,
        },
        {
            start: '2023-01-27T17:45:00.000-07:00',
            end: '2023-01-27T18:30:00.000-07:00',
            providerId: null,
            eventId: '7k81p4teackhrbrfcncisjlqn4_20230127T231500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take call & Commute',
            timeZone: null,
        },
        {
            start: '2023-01-27T18:00:00.000-07:00',
            end: '2023-01-27T18:30:00.000-07:00',
            providerId: null,
            eventId: 'r0s9vhtnbi5u5tl6425f1sm8d4',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: 'Porridge & Things, 235 Broadway, Millbrae, CA 94030, USA',
            recurrence: null,
            summary: 'Pick up 盆菜',
            timeZone: null,
        },
        {
            start: '2023-01-27T22:00:00.000-07:00',
            end: '2023-01-27T23:00:00.000-07:00',
            providerId: null,
            eventId: '5j7sgrfd01lmgh149s2t5q6ghk_20230128T050000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '5',
            description: null,
            email: ['xujunliu1987@gmail.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Family Time',
            timeZone: null,
        },
        {
            start: '2023-01-27T23:00:00.000-07:00',
            end: '2023-01-28T08:00:00.000-07:00',
            providerId: null,
            eventId: 'lnjbph8ng0dlud6r5oqmfrr492_20230128T060000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'DNA',
            timeZone: null,
        },
        {
            start: '2023-01-28T08:00:00.000-07:00',
            end: '2023-01-28T08:30:00.000-07:00',
            providerId: null,
            eventId: '3pmv6sh8q2khsper23mut1vc0h',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: [
                'xiaocong.liu@helloklarity.com',
                'xiaohong.wu@helloklarity.com',
                'kunqian.fan@helloklarity.com',
                'cecilia.zhao@helloklarity.com',
                'zhengkai.zou@helloklarity.com',
                'guorui.su@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'Channel Project sync',
            timeZone: null,
        },
        {
            start: '2023-01-28T09:00:00.000-07:00',
            end: '2023-01-28T09:45:00.000-07:00',
            providerId: null,
            eventId: 'cub7cvvnaqi1eul4s0keb92qa3_20230128T160000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take calls; dog walk, breakfast prep, commute',
            timeZone: null,
        },
        {
            start: '2023-01-28T17:00:00.000-07:00',
            end: '2023-01-28T17:30:00.000-07:00',
            providerId: null,
            eventId: '79dh20galh472m3dtf2o2dicc8',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['xujunliu1987@gmail.com', 'guorui.su@helloklarity.com'],
            location: '3rd Avenue 30 E 3rd Ave, San Mateo, CA, USA Pickup location',
            recurrence: null,
            summary: 'Pick up Luluyum',
            timeZone: null,
        },
        {
            start: '2023-01-28T17:30:00.000-07:00',
            end: '2023-01-28T18:00:00.000-07:00',
            providerId: null,
            eventId: 'qfsq716gsvopp53po7rgkvrg6g',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: '1136 S De Anza Blvd, San Jose, CA 95129, USA',
            recurrence: null,
            summary: 'Bing cai',
            timeZone: null,
        },
        {
            start: '2023-01-28T22:00:00.000-07:00',
            end: '2023-01-28T23:00:00.000-07:00',
            providerId: null,
            eventId: '5j7sgrfd01lmgh149s2t5q6ghk_20230129T050000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '5',
            description: null,
            email: ['xujunliu1987@gmail.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Family Time',
            timeZone: null,
        },
        {
            start: '2023-01-28T23:00:00.000-07:00',
            end: '2023-01-29T08:00:00.000-07:00',
            providerId: null,
            eventId: 'lnjbph8ng0dlud6r5oqmfrr492_20230129T060000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'DNA',
            timeZone: null,
        },
        {
            start: '2023-01-29T09:00:00.000-07:00',
            end: '2023-01-29T09:45:00.000-07:00',
            providerId: null,
            eventId: 'cub7cvvnaqi1eul4s0keb92qa3_20230129T160000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take calls; dog walk, breakfast prep, commute',
            timeZone: null,
        },
        {
            start: '2023-01-29T22:00:00.000-07:00',
            end: '2023-01-29T23:00:00.000-07:00',
            providerId: null,
            eventId: '5j7sgrfd01lmgh149s2t5q6ghk_20230130T050000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '5',
            description: null,
            email: ['xujunliu1987@gmail.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Family Time',
            timeZone: null,
        },
        {
            start: '2023-01-29T23:00:00.000-07:00',
            end: '2023-01-30T08:00:00.000-07:00',
            providerId: null,
            eventId: 'lnjbph8ng0dlud6r5oqmfrr492_20230130T060000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'DNA',
            timeZone: null,
        },
        {
            start: '2023-01-30T08:45:00.000-07:00',
            end: '2023-01-30T09:30:00.000-07:00',
            providerId: null,
            eventId: 'cub7cvvnaqi1eul4s0keb92qa3_20230130T160000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take calls; dog walk, breakfast prep, commute',
            timeZone: null,
        },
        {
            start: '2023-01-30T09:30:00.000-07:00',
            end: '2023-01-30T10:30:00.000-07:00',
            providerId: null,
            eventId: '6b2ll30nu1g6ngl74ludclnh81',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['andrew.aj.lin@hotmail.com', 'guorui.su@helloklarity.com'],
            location: '400 Walnut St, Redwood City, CA 94063',
            recurrence: null,
            summary: '[In-person] Andrew / Guorui @Starbucks',
            timeZone: null,
        },
        {
            start: '2023-01-30T13:00:00.000-07:00',
            end: '2023-01-30T13:30:00.000-07:00',
            providerId: null,
            eventId: '3o5nve0k9drhlnpuk3h4vhgvaq_20230130T200000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'lunch',
            timeZone: null,
        },
        {
            start: '2023-01-30T13:30:00.000-07:00',
            end: '2023-01-30T14:00:00.000-07:00',
            providerId: null,
            eventId: '68lcjpo61v3je6t729ovdr760d_20230127T180000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: 'Lillian Ma',
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['lillian.ma@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Lillian / Guorui - In-person catch-up',
            timeZone: null,
        },
        {
            start: '2023-01-30T14:00:00.000-07:00',
            end: '2023-01-30T14:30:00.000-07:00',
            providerId: null,
            eventId: 'mfk0ug11qj8h5451d979q90neo_20230130T180000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '4',
            description: null,
            email: ['catherine.zhang@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Catherine/Guorui 1-1',
            timeZone: null,
        },
        {
            start: '2023-01-30T14:30:00.000-07:00',
            end: '2023-01-30T16:30:00.000-07:00',
            providerId: null,
            eventId: '4cu2a7jgjdps1rl1tsc1fl84de',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['sugar.rui.wang@gmail.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: '[In-person] Marketplace algorithm breakstorming',
            timeZone: null,
        },
        {
            start: '2023-01-30T18:00:00.000-07:00',
            end: '2023-01-30T18:45:00.000-07:00',
            providerId: null,
            eventId: 'vn4u8qm68a66iaqc9n6s41rsft_20230131T010000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                'Notes:&nbsp;<a href="https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c" style="background-color: var(--textfield-surface);">https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c</a>',
            email: [
                'youming.tang@helloklarity.com',
                'xiaohong.wu@helloklarity.com',
                'catherine.zhang@helloklarity.com',
                'guorui.su@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'BoxPractice Sprint (2/2) - ProviderExperience',
            timeZone: null,
        },
        {
            start: '2023-01-30T19:00:00.000-07:00',
            end: '2023-01-30T19:45:00.000-07:00',
            providerId: null,
            eventId: '7k81p4teackhrbrfcncisjlqn4_20230130T231500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take call & Commute',
            timeZone: null,
        },
        {
            start: '2023-01-30T22:00:00.000-07:00',
            end: '2023-01-30T23:00:00.000-07:00',
            providerId: null,
            eventId: '5j7sgrfd01lmgh149s2t5q6ghk_20230131T050000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '5',
            description: null,
            email: ['xujunliu1987@gmail.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Family Time',
            timeZone: null,
        },
        {
            start: '2023-01-30T23:00:00.000-07:00',
            end: '2023-01-31T08:00:00.000-07:00',
            providerId: null,
            eventId: 'lnjbph8ng0dlud6r5oqmfrr492_20230131T060000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'DNA',
            timeZone: null,
        },
        {
            start: '2023-01-31T08:15:00.000-07:00',
            end: '2023-01-31T09:00:00.000-07:00',
            providerId: null,
            eventId: 's0h331gf0pplirvnam33tocqba_20230131T151500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '4',
            description:
                '<html-blob><u></u><br><u></u><br><u></u>We\'ll use this doc for meeting note:&nbsp;<a href="https://www.notion.so/klarityhealth/Meeting-Notes-65dc7d8d16fb4a4d9ebb18c2c985771a" id="ow684" __is_owner="true">https://www.notion.so/klarityhealth/Meeting-Notes-65dc7d8d16fb4a4d9ebb18c2c985771a</a><br><br><br><u></u>Su Guorui invites you to a meeting on VooV Meeting<br>Meeting Topic: Product Weekly<br>Meeting Time: 2022/09/06 08:00-09:00 (GMT-07:00) Pacific Time - Los Angeles<br>Recurrence: 2022/09/06-2023/09/05 08:00-09:00, Every Tuesday<br><br>Click the link to join the meeting or to add it to your meeting list:<br><a href="https://voovmeeting.com/dm/5j0Pkqqp5QGM">https://voovmeeting.com/dm/5j0Pkqqp5QGM</a><br><br>#VooVMeeting：368-0734-7269<u></u></html-blob>',
            email: [
                'cecilia.zhao@helloklarity.com',
                'guorui.su@helloklarity.com',
                'jason.shao@helloklarity.com',
                'stacey.yao@helloklarity.com',
                'mark.ma@helloklarity.com',
                'kunqian.fan@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
                'aditya.joshi@helloklarity.com',
            ],
            location: 'https://voovmeeting.com/dm/5j0Pkqqp5QGM',
            recurrence: null,
            summary: 'Marketplace Product Weekly / Sprint ',
            timeZone: null,
        },
        {
            start: '2023-01-31T09:00:00.000-07:00',
            end: '2023-01-31T09:45:00.000-07:00',
            providerId: null,
            eventId: 'cub7cvvnaqi1eul4s0keb92qa3_20230131T160000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take calls; dog walk, breakfast prep, commute',
            timeZone: null,
        },
        {
            start: '2023-01-31T13:00:00.000-07:00',
            end: '2023-01-31T13:30:00.000-07:00',
            providerId: null,
            eventId: '3o5nve0k9drhlnpuk3h4vhgvaq_20230131T200000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'lunch',
            timeZone: null,
        },
        {
            start: '2023-01-31T16:00:00.000-07:00',
            end: '2023-01-31T16:30:00.000-07:00',
            providerId: null,
            eventId: '85a2v2ukbs9g065rqkul3fg4du_20230131T190000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['victor.zhou@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Victor / Guorui - Daily Standup',
            timeZone: null,
        },
        {
            start: '2023-01-31T16:30:00.000-07:00',
            end: '2023-01-31T17:00:00.000-07:00',
            providerId: null,
            eventId: '6g1jd3iidks9jc4tt1m2bt2ju0_20230131T233000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['youming.tang@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Youming/Guorui touchbase',
            timeZone: null,
        },
        {
            start: '2023-01-31T17:15:00.000-07:00',
            end: '2023-01-31T18:00:00.000-07:00',
            providerId: null,
            eventId: '3atu6a2t3gd4ltjquere2afe82_20230201T001500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['xiaocong.liu@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Xiaocong:Guorui weekly 1-1',
            timeZone: null,
        },
        {
            start: '2023-01-31T18:00:00.000-07:00',
            end: '2023-01-31T18:45:00.000-07:00',
            providerId: null,
            eventId: 'ff1f11k3rs35pdkcn571jm95on_20230201T010000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '4',
            description:
                'Co-working on product, tech, and design roadmap for our BoxPractice (SaaS Product)<br><br>Ongoing Meeting Notes: <a href="https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c">https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c</a><p><br>──────────<br><br>Guorui Su is inviting you to a scheduled Zoom meeting.<br><br>Join Zoom Meeting<br>https://us06web.zoom.us/j/85635757228?pwd=WVNnZVNWSzMzYm44N3NaejJZQkg0UT09<br><br>Meeting ID: 856 3575 7228<br>Passcode: 995654<br><br><br><br>──────────</p>',
            email: [
                'xiaohong.wu@helloklarity.com',
                'catherine.zhang@helloklarity.com',
                'guorui.su@helloklarity.com',
                'cecilia.zhao@helloklarity.com',
                'youming.tang@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
                'kunqian.fan@helloklarity.com',
                'zhengkai.zou@helloklarity.com',
                'jason.shao@helloklarity.com',
            ],
            location:
                'https://us06web.zoom.us/j/85635757228?pwd=WVNnZVNWSzMzYm44N3NaejJZQkg0UT09',
            recurrence: null,
            summary: 'BoxPractice Sprint (1/2)- Channels / PF / PPP',
            timeZone: null,
        },
        {
            start: '2023-01-31T22:00:00.000-07:00',
            end: '2023-01-31T23:00:00.000-07:00',
            providerId: null,
            eventId: '5j7sgrfd01lmgh149s2t5q6ghk_20230201T050000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '5',
            description: null,
            email: ['xujunliu1987@gmail.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Family Time',
            timeZone: null,
        },
        {
            start: '2023-01-31T23:00:00.000-07:00',
            end: '2023-02-01T08:00:00.000-07:00',
            providerId: null,
            eventId: 'lnjbph8ng0dlud6r5oqmfrr492_20230201T060000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'DNA',
            timeZone: null,
        },
        {
            start: '2023-02-01T09:00:00.000-07:00',
            end: '2023-02-01T09:45:00.000-07:00',
            providerId: null,
            eventId: 'cub7cvvnaqi1eul4s0keb92qa3_20230201T160000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take calls; dog walk, breakfast prep, commute',
            timeZone: null,
        },
        {
            start: '2023-02-01T09:15:00.000-07:00',
            end: '2023-02-01T10:00:00.000-07:00',
            providerId: null,
            eventId: 't572q84m7kp1umulhiult3dc5r_20230201T161500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: 'guorui.su@helloklarity.com',
            patientPhone: null,
            sendForm: null,
            colorId: '3',
            description: null,
            email: ['guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Focus time - Backlog Review & Product Brief ',
            timeZone: null,
        },
        {
            start: '2023-02-01T10:00:00.000-07:00',
            end: '2023-02-01T10:30:00.000-07:00',
            providerId: null,
            eventId: '10s1vcqgc3c7ncn1viiumhvvfm',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['stacey.yao@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Stacey:Guorui',
            timeZone: null,
        },
        {
            start: '2023-02-01T10:30:00.000-07:00',
            end: '2023-02-01T11:30:00.000-07:00',
            providerId: null,
            eventId: '541jtgoc38ks4f3464jvmah1ov',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: 'Victor (Work)',
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: [
                'victor.zhou@helloklarity.com',
                'david.queen@helloklarity.com',
                'clara.kennedy@helloklarity.com',
                'guorui.su@helloklarity.com',
                'valerie.martnick@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'Marketplace Ops offsite agenda and prep sync',
            timeZone: null,
        },
        {
            start: '2023-02-01T13:00:00.000-07:00',
            end: '2023-02-01T13:30:00.000-07:00',
            providerId: null,
            eventId: '3o5nve0k9drhlnpuk3h4vhgvaq_20230201T200000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'lunch',
            timeZone: null,
        },
        {
            start: '2023-02-01T13:00:00.000-07:00',
            end: '2023-02-01T14:00:00.000-07:00',
            providerId: null,
            eventId: 'vh4a6gu3rl5s1dk21e88tvp2pk',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: 'Block created via IntakeQ.',
            email: null,
            location: null,
            recurrence: null,
            summary: 'test',
            timeZone: null,
        },
        {
            start: '2023-02-01T14:30:00.000-07:00',
            end: '2023-02-01T15:00:00.000-07:00',
            providerId: null,
            eventId: '3ms9sbjjencqlnnkuvell72qfd',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: 'Catherine Zhang',
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['catherine.zhang@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Catherine / Guorui',
            timeZone: null,
        },
        {
            start: '2023-02-01T15:00:00.000-07:00',
            end: '2023-02-01T16:00:00.000-07:00',
            providerId: null,
            eventId: 'd37ak345jqem1fqcm1vfhouigl_20230201T183000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: 'Lillian Ma',
            patientPhone: null,
            sendForm: null,
            colorId: '5',
            description:
                "Hi Lillian,\n\nLong due weekly 1-1. Let's use this cadence to sync product dev progress, analytics progress / insights, marketing insights, team & recruiting, and interdependencies. \n\nGuorui",
            email: ['lillian.ma@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Lillian / Guorui 1-1 (weekly in-depth)',
            timeZone: null,
        },
        {
            start: '2023-02-01T17:00:00.000-07:00',
            end: '2023-02-01T17:30:00.000-07:00',
            providerId: null,
            eventId: '6mu1a0tdkdu2h0m23vos0pmgtt',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: 'Cecilia Zhao',
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['cecilia.zhao@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Cecilia / Guorui',
            timeZone: null,
        },
        {
            start: '2023-02-01T17:30:00.000-07:00',
            end: '2023-02-01T18:15:00.000-07:00',
            providerId: null,
            eventId: '7k81p4teackhrbrfcncisjlqn4_20230201T231500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take call & Commute',
            timeZone: null,
        },
        {
            start: '2023-02-01T22:00:00.000-07:00',
            end: '2023-02-01T23:00:00.000-07:00',
            providerId: null,
            eventId: '5j7sgrfd01lmgh149s2t5q6ghk_20230202T050000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '5',
            description: null,
            email: ['xujunliu1987@gmail.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Family Time',
            timeZone: null,
        },
        {
            start: '2023-02-01T23:00:00.000-07:00',
            end: '2023-02-02T08:00:00.000-07:00',
            providerId: null,
            eventId: 'lnjbph8ng0dlud6r5oqmfrr492_20230202T060000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'DNA',
            timeZone: null,
        },
        {
            start: '2023-02-02T08:00:00.000-07:00',
            end: '2023-02-02T08:30:00.000-07:00',
            providerId: null,
            eventId: '5vm8b8b6aosjaegldkd1d72ogm',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: [
                'xiaocong.liu@helloklarity.com',
                'xiaohong.wu@helloklarity.com',
                'catherine.zhang@helloklarity.com',
                'jason.shao@helloklarity.com',
                'guorui.su@helloklarity.com',
            ],
            location: null,
            recurrence: null,
            summary: 'IntakeQ调研结果跟进',
            timeZone: null,
        },
        {
            start: '2023-02-02T08:30:00.000-07:00',
            end: '2023-02-02T09:00:00.000-07:00',
            providerId: null,
            eventId: '15j2nblcfcpqpq6ubtb2eva05i',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: 'guorui.su@helloklarity.com',
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Out of office - coffee',
            timeZone: null,
        },
        {
            start: '2023-02-02T09:00:00.000-07:00',
            end: '2023-02-02T09:45:00.000-07:00',
            providerId: null,
            eventId: 'cub7cvvnaqi1eul4s0keb92qa3_20230202T160000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take calls; dog walk, breakfast prep, commute',
            timeZone: null,
        },
        {
            start: '2023-02-02T10:30:00.000-07:00',
            end: '2023-02-02T11:00:00.000-07:00',
            providerId: null,
            eventId: '2crsdh3oijtejsubugumit5qr8',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: '- Klarity 五险一金比例',
            email: ['ethan.yang@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Ethan / Guorui - catch-up',
            timeZone: null,
        },
        {
            start: '2023-02-02T11:30:00.000-07:00',
            end: '2023-02-02T12:00:00.000-07:00',
            providerId: null,
            eventId: 'mfk0ug11qj8h5451d979q90neo_20230202T180000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '4',
            description: null,
            email: ['catherine.zhang@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Catherine/Guorui 1-1',
            timeZone: null,
        },
        {
            start: '2023-02-02T12:00:00.000-07:00',
            end: '2023-02-02T12:30:00.000-07:00',
            providerId: null,
            eventId: '85a2v2ukbs9g065rqkul3fg4du_20230202T190000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['victor.zhou@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Victor / Guorui - Daily Standup',
            timeZone: null,
        },
        {
            start: '2023-02-02T13:00:00.000-07:00',
            end: '2023-02-02T14:00:00.000-07:00',
            providerId: null,
            eventId: '2d1b9ucipbb32etnli51eou27s',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['xujunliu1987@gmail.com', 'guorui.su@helloklarity.com'],
            location: '1500 Sullivan Ave, Daly City, CA 94015, USA',
            recurrence: null,
            summary: 'Out of office - DMV',
            timeZone: null,
        },
        {
            start: '2023-02-02T13:00:00.000-07:00',
            end: '2023-02-02T13:30:00.000-07:00',
            providerId: null,
            eventId: '3o5nve0k9drhlnpuk3h4vhgvaq_20230202T200000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'lunch',
            timeZone: null,
        },
        {
            start: '2023-02-02T14:30:00.000-07:00',
            end: '2023-02-02T15:30:00.000-07:00',
            providerId: null,
            eventId: '6n1i5ejmlgqmkg8311vt70ttvb',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['jason@projectvillage.io', 'guorui.su@helloklarity.com'],
            location:
                '2248 Westborough Blvd Suite 603, South San Francisco, CA 94080',
            recurrence: null,
            summary: '[In-person] JC-Guorui at Philz Coffee',
            timeZone: null,
        },
        {
            start: '2023-02-02T16:00:00.000-07:00',
            end: '2023-02-02T17:00:00.000-07:00',
            providerId: null,
            eventId: '1720g7vcrsi2upi6noq6d32jnb',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'offsite prep',
            timeZone: null,
        },
        {
            start: '2023-02-02T22:00:00.000-07:00',
            end: '2023-02-02T23:00:00.000-07:00',
            providerId: null,
            eventId: '5j7sgrfd01lmgh149s2t5q6ghk_20230203T050000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '5',
            description: null,
            email: ['xujunliu1987@gmail.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Family Time',
            timeZone: null,
        },
        {
            start: '2023-02-02T23:00:00.000-07:00',
            end: '2023-02-03T08:00:00.000-07:00',
            providerId: null,
            eventId: 'lnjbph8ng0dlud6r5oqmfrr492_20230203T060000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'DNA',
            timeZone: null,
        },
        {
            start: '2023-02-03T09:00:00.000-07:00',
            end: '2023-02-03T09:45:00.000-07:00',
            providerId: null,
            eventId: 'cub7cvvnaqi1eul4s0keb92qa3_20230203T160000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take calls; dog walk, breakfast prep, commute',
            timeZone: null,
        },
        {
            start: '2023-02-03T12:00:00.000-07:00',
            end: '2023-02-03T13:00:00.000-07:00',
            providerId: null,
            eventId: '7ssu4jdrru0146l5c9e94ldcv9',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: 'Lillian Ma',
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['lillian.ma@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Hold: Marketplace Ops offsite presentation review',
            timeZone: null,
        },
        {
            start: '2023-02-03T13:00:00.000-07:00',
            end: '2023-02-03T14:30:00.000-07:00',
            providerId: null,
            eventId: '3egrt52e483ll7ol0m90j3v936',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: 'Victor (Work)',
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['victor.zhou@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: '[In-person] Victor / Guorui - offsite sync & Lunch',
            timeZone: null,
        },
        {
            start: '2023-02-03T13:00:00.000-07:00',
            end: '2023-02-03T13:30:00.000-07:00',
            providerId: null,
            eventId: '3o5nve0k9drhlnpuk3h4vhgvaq_20230203T200000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'lunch',
            timeZone: null,
        },
        {
            start: '2023-02-03T15:15:00.000-07:00',
            end: '2023-02-03T16:00:00.000-07:00',
            providerId: null,
            eventId: '7k81p4teackhrbrfcncisjlqn4_20230203T231500Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take call & Commute',
            timeZone: null,
        },
        {
            start: '2023-02-03T15:30:00.000-07:00',
            end: '2023-02-03T16:15:00.000-07:00',
            providerId: null,
            eventId: 'sfab28g6ktope7mj41mcu6noq5_20230203T223000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: 'guorui.su@helloklarity.com',
            patientPhone: null,
            sendForm: null,
            colorId: '3',
            description: null,
            email: ['guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Focus time - weekly summary',
            timeZone: null,
        },
        {
            start: '2023-02-03T16:00:00.000-07:00',
            end: '2023-02-03T17:00:00.000-07:00',
            providerId: null,
            eventId: '1aru3rtmjccmn1vfmrvs3h8j2t',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: '<br><h1>Bluestone Lane Los Altos Café</h1>',
            email: ['atiwari@gmail.com', 'guorui.su@helloklarity.com'],
            location: '288 1st St, Los Altos, CA 94022',
            recurrence: null,
            summary: '[In-person] meeting with Arpana Tiwari',
            timeZone: null,
        },
        {
            start: '2023-02-03T22:00:00.000-07:00',
            end: '2023-02-03T23:00:00.000-07:00',
            providerId: null,
            eventId: '5j7sgrfd01lmgh149s2t5q6ghk_20230204T050000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '5',
            description: null,
            email: ['xujunliu1987@gmail.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Family Time',
            timeZone: null,
        },
        {
            start: '2023-02-03T23:00:00.000-07:00',
            end: '2023-02-04T08:00:00.000-07:00',
            providerId: null,
            eventId: 'lnjbph8ng0dlud6r5oqmfrr492_20230204T060000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'DNA',
            timeZone: null,
        },
        {
            start: '2023-02-04T09:00:00.000-07:00',
            end: '2023-02-04T09:45:00.000-07:00',
            providerId: null,
            eventId: 'cub7cvvnaqi1eul4s0keb92qa3_20230204T160000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '10',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Can take calls; dog walk, breakfast prep, commute',
            timeZone: null,
        },
        {
            start: '2023-02-04T22:00:00.000-07:00',
            end: '2023-02-04T23:00:00.000-07:00',
            providerId: null,
            eventId: '5j7sgrfd01lmgh149s2t5q6ghk_20230205T050000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '5',
            description: null,
            email: ['xujunliu1987@gmail.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Family Time',
            timeZone: null,
        },
        {
            start: '2023-02-04T23:00:00.000-07:00',
            end: '2023-02-05T08:00:00.000-07:00',
            providerId: null,
            eventId: 'lnjbph8ng0dlud6r5oqmfrr492_20230205T060000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'DNA',
            timeZone: null,
        },
        {
            start: '2023-02-05T09:00:00.000-07:00',
            end: '2023-02-05T10:00:00.000-07:00',
            providerId: null,
            eventId: '7p765885oqqh6h65nbji2l0713',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['victor.zhou@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Victor:Guorui',
            timeZone: null,
        },
        {
            start: '2023-02-05T18:00:00.000-07:00',
            end: '2023-02-05T20:00:00.000-07:00',
            providerId: null,
            eventId: 'rpsm8pu40vm4efrc2arl4jdmuc',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'Jack’s ramen opening',
            timeZone: null,
        },
        {
            start: '2023-02-05T22:00:00.000-07:00',
            end: '2023-02-05T23:00:00.000-07:00',
            providerId: null,
            eventId: '5j7sgrfd01lmgh149s2t5q6ghk_20230206T050000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '5',
            description: null,
            email: ['xujunliu1987@gmail.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Family Time',
            timeZone: null,
        },
        {
            start: '2023-02-05T23:00:00.000-07:00',
            end: '2023-02-06T08:00:00.000-07:00',
            providerId: null,
            eventId: 'lnjbph8ng0dlud6r5oqmfrr492_20230206T060000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'DNA',
            timeZone: null,
        },
        {
            start: '2023-02-06T09:00:00.000-07:00',
            end: '2023-02-06T09:30:00.000-07:00',
            providerId: null,
            eventId: 'q4krf38i3dj83ai5n1dp3jrme0',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                "Event Name: 30min Phone Call with Guorui\n\nI'll give you a call at the designated time. My number is 6504503721.\n\nLocation: +1 408-493-9278\n\nNeed to make changes to this event?\nCancel: https://calendly.com/cancellations/b9e55bcf-c2e3-432c-b586-3739234f44ca\nReschedule: https://calendly.com/reschedulings/b9e55bcf-c2e3-432c-b586-3739234f44ca\n\nPowered by Calendly.com\n",
            email: ['jessz97123@gmail.com', 'guorui.su@helloklarity.com'],
            location: '+1 408-493-9278',
            recurrence: null,
            summary: 'Jesssica Zhang and Guorui Su',
            timeZone: null,
        },
        {
            start: '2023-02-06T09:30:00.000-07:00',
            end: '2023-02-06T10:00:00.000-07:00',
            providerId: null,
            eventId: '0qbah0gaafv5mhu5vvf26psngf',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: ['aditya.joshi@helloklarity.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Aditya / Guorui - catch-up',
            timeZone: null,
        },
        {
            start: '2023-02-06T10:30:00.000-07:00',
            end: '2023-02-06T18:00:00.000-07:00',
            providerId: null,
            eventId: '219n7rc4otpfathhv4cluir2oc_20230206T173000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description: null,
            email: [
                'victor.zhou@helloklarity.com',
                'lillian.ma@helloklarity.com',
                'david.queen@helloklarity.com',
                'guorui.su@helloklarity.com',
                'clara.kennedy@helloklarity.com',
                'valerie.martnick@helloklarity.com',
                'aman.bansal@helloklarity.com',
                'aditya.joshi@helloklarity.com',
            ],
            location: '370 Convention Way, 221 Redwood City CA 94063 United States',
            recurrence: null,
            summary: '[In-Person] Marketplace Ops Offsite',
            timeZone: null,
        },
        {
            start: '2023-02-06T13:00:00.000-07:00',
            end: '2023-02-06T13:30:00.000-07:00',
            providerId: null,
            eventId: '3o5nve0k9drhlnpuk3h4vhgvaq_20230206T200000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '8',
            description: null,
            email: null,
            location: null,
            recurrence: null,
            summary: 'lunch',
            timeZone: null,
        },
        {
            start: '2023-02-06T18:00:00.000-07:00',
            end: '2023-02-06T18:45:00.000-07:00',
            providerId: null,
            eventId: 'vn4u8qm68a66iaqc9n6s41rsft_20230207T010000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: null,
            description:
                'Notes: <a href="https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c">https://www.notion.so/klarityhealth/BP-Sprint-Planning-59956306bda7423f88c1f6e5bcd4b90c</a><p><br>──────────<br><br>Guorui Su is inviting you to a scheduled Zoom meeting.<br><br>Join Zoom Meeting<br>https://us06web.zoom.us/j/87858452164?pwd=RTNqcXhEdmozOS9YNHdMQ1Z0c2dMdz09<br><br>Meeting ID: 878 5845 2164<br>Passcode: 330782<br><br><br><br>──────────</p>',
            email: [
                'youming.tang@helloklarity.com',
                'xiaohong.wu@helloklarity.com',
                'catherine.zhang@helloklarity.com',
                'guorui.su@helloklarity.com',
                'xiaocong.liu@helloklarity.com',
            ],
            location:
                'https://us06web.zoom.us/j/87858452164?pwd=RTNqcXhEdmozOS9YNHdMQ1Z0c2dMdz09',
            recurrence: null,
            summary: 'BoxPractice Sprint (2/2) - ProviderExperience',
            timeZone: null,
        },
        {
            start: '2023-02-06T22:00:00.000-07:00',
            end: '2023-02-06T23:00:00.000-07:00',
            providerId: null,
            eventId: '5j7sgrfd01lmgh149s2t5q6ghk_20230207T050000Z',
            channelId: null,
            serviceId: null,
            duration: null,
            meetingLink: null,
            patientName: null,
            patientPhone: null,
            sendForm: null,
            colorId: '5',
            description: null,
            email: ['xujunliu1987@gmail.com', 'guorui.su@helloklarity.com'],
            location: null,
            recurrence: null,
            summary: 'Family Time',
            timeZone: null,
        },
    ],
};

export const scheduleEvent = {
    kind: 'calendar#event',
    etag: '"3352884840028000"',
    id: '9gmnlpadmceu1nv4i76mh84dds_20230215T160000Z',
    status: 'confirmed',
    htmlLink: 'https://www.google.com/calendar/event?eid=OWdtbmxwYWRtY2V1MW52NGk3Nm1oODRkZHNfMjAyMzAyMTVUMTYwMDAwWiB4aWFvY29uZy5saXVAaGVsbG9rbGFyaXR5LmNvbQ',
    created: '2023-02-15T06:27:00.000Z',
    updated: '2023-02-15T06:27:00.014Z',
    summary: '[Klarity] - schedule',
    description: '[Klarity] - schedule \n [Guest]:evanliu.it@gmail.com',
    location: 'china',
    colorId: '5',
    creator: {
        email: 'xiaocong.liu@helloklarity.com',
        self: true,
    },
    organizer: {
        email: 'xiaocong.liu@helloklarity.com',
        self: true,
    },
    start: {
        dateTime: '2023-02-16T00:00:00+08:00',
        timeZone: 'Asia/Singapore',
    },
    end: {
        dateTime: '2023-02-16T00:45:00+08:00',
        timeZone: 'Asia/Singapore',
    },
    recurringEventId: '9gmnlpadmceu1nv4i76mh84dds',
    originalStartTime: {
        dateTime: '2023-02-16T00:00:00+08:00',
        timeZone: 'Asia/Singapore',
    },
    iCalUID: '9gmnlpadmceu1nv4i76mh84dds@google.com',
    sequence: 0,
    attendees: [
        {
            email: 'evanliu.it@gmail.com',
            responseStatus: 'needsAction',
        },
    ],
    reminders: {
        useDefault: false,
        overrides: [
            {
                method: 'popup',
                minutes: 10,
            },
            {
                method: 'email',
                minutes: 1440,
            },
        ],
    },
    eventType: 'default',
};

export const reputationProviderData = {
    invitationEmail: {
        subject: 'Your feedback matters to [Provider name]: take a quick survey',
        content: 'We partner with [provider name] to gather valuable feedback from care recipients like you. Your honest feedback and input is crucial to improving the services offered by [Provider\'s Name].<div><br></div>Please take a moment to share your thoughts by completing a short survey. It\'s quick, easy, and most importantly, your responses will directly contribute to making your future visits even better.<div><br></div>Your responses will remain confidential unless you allow the provider to follow up. It will be used solely to enhance the care experience.<div><br></div>',
    },
    survey: [
        {
            title: 0,
        },
        {
            title: 'Is there anything you\'d like to share or suggest to provider {provider name}?',
            subText: 'Your feedback is essential in helping the provider enhance their services.',
        },
        {
            title: 'Would you like [Provider name], [Provider Credential] to contact you for follow-up based on your feedback? ',
            subText: 'Selecting \'Yes\' indicates your consent to share your contact information, along with your rating and feedback with the provider.',
        },
    ],
    review: {
        channelList: [],
        scores: 4,
        email: {
            subject: 'Thanks for responding to survey! Please help us by leaving a review.',
            content: 'Thank you for taking the time to respond to my recent survey. I truly appreciate your valuable input. If you could spare a moment, I would be grateful if you could share your experience by leaving a review.\r\nClick on the button below to leave a review on the platform of your choice.\r\nTo protect your privacy, please remember that you should not feel the need to share your full or real name when you post a review. Please use the provided link. Your responses remain confidential unless you\'ve chosen to share them.\r\nThank you once again for choosing me for your healthcare needs. ',
        },
    },
};

export const states = [
    { id: 17, type: 'STATE', dictKey: 'AL', content: 'Alabama', description: null }, { id: 18, type: 'STATE', dictKey: 'AK', content: 'Alaska', description: null },
    { id: 133, type: 'STATE', dictKey: 'AZ', content: 'Arizona', description: null }, { id: 134, type: 'STATE', dictKey: 'AR', content: 'Arkansas', description: null }, { id: 135, type: 'STATE', dictKey: 'CA', content: 'California', description: null }, { id: 136, type: 'STATE', dictKey: 'CO', content: 'Colorado', description: null }, { id: 137, type: 'STATE', dictKey: 'CT', content: 'Connecticut', description: null }, { id: 138, type: 'STATE', dictKey: 'DE', content: 'Delaware', description: null }, { id: 139, type: 'STATE', dictKey: 'DC', content: 'District of Columbia', description: null }, { id: 140, type: 'STATE', dictKey: 'FL', content: 'Florida', description: null }, { id: 141, type: 'STATE', dictKey: 'GA', content: 'Georgia', description: null }, { id: 142, type: 'STATE', dictKey: 'HI', content: 'Hawaii', description: null }, { id: 143, type: 'STATE', dictKey: 'ID', content: 'Idaho', description: null }, { id: 144, type: 'STATE', dictKey: 'IL', content: 'Illinois', description: null }, { id: 145, type: 'STATE', dictKey: 'IN', content: 'Indiana', description: null }, { id: 146, type: 'STATE', dictKey: 'IA', content: 'Iowa', description: null }, { id: 147, type: 'STATE', dictKey: 'KS', content: 'Kansas', description: null }, { id: 148, type: 'STATE', dictKey: 'KY', content: 'Kentucky', description: null }, { id: 149, type: 'STATE', dictKey: 'LA', content: 'Louisiana', description: null }, { id: 150, type: 'STATE', dictKey: 'ME', content: 'Maine', description: null }, { id: 151, type: 'STATE', dictKey: 'MD', content: 'Maryland', description: null }, { id: 152, type: 'STATE', dictKey: 'MA', content: 'Massachusetts', description: null }, { id: 153, type: 'STATE', dictKey: 'MI', content: 'Michigan', description: null }, { id: 154, type: 'STATE', dictKey: 'MN', content: 'Minnesota', description: null }, { id: 155, type: 'STATE', dictKey: 'MS', content: 'Mississippi', description: null }, { id: 156, type: 'STATE', dictKey: 'MO', content: 'Missouri', description: null }, { id: 157, type: 'STATE', dictKey: 'MT', content: 'Montana', description: null }, { id: 158, type: 'STATE', dictKey: 'NE', content: 'Nebraska', description: null }, { id: 159, type: 'STATE', dictKey: 'NV', content: 'Nevada', description: null }, { id: 160, type: 'STATE', dictKey: 'NH', content: 'New Hampshire', description: null }, { id: 161, type: 'STATE', dictKey: 'NJ', content: 'New Jersey', description: null }, { id: 162, type: 'STATE', dictKey: 'NM', content: 'New Mexico', description: null }, { id: 163, type: 'STATE', dictKey: 'NY', content: 'New York', description: null }, { id: 164, type: 'STATE', dictKey: 'NC', content: 'North Carolina', description: null }, { id: 165, type: 'STATE', dictKey: 'ND', content: 'North Dakota', description: null }, { id: 166, type: 'STATE', dictKey: 'OH', content: 'Ohio', description: null }, { id: 167, type: 'STATE', dictKey: 'OK', content: 'Oklahoma', description: null }, { id: 168, type: 'STATE', dictKey: 'OR', content: 'Oregon', description: null }, { id: 169, type: 'STATE', dictKey: 'PA', content: 'Pennsylvania', description: null }, { id: 170, type: 'STATE', dictKey: 'RI', content: 'Rhode Island', description: null }, { id: 171, type: 'STATE', dictKey: 'SC', content: 'South Carolina', description: null }, { id: 172, type: 'STATE', dictKey: 'SD', content: 'South Dakota', description: null }, { id: 173, type: 'STATE', dictKey: 'TN', content: 'Tennessee', description: null }, { id: 174, type: 'STATE', dictKey: 'TX', content: 'Texas', description: null }, { id: 175, type: 'STATE', dictKey: 'UT', content: 'Utah', description: null }, { id: 176, type: 'STATE', dictKey: 'VT', content: 'Vermont', description: null }, { id: 177, type: 'STATE', dictKey: 'VA', content: 'Virginia', description: null }, { id: 178, type: 'STATE', dictKey: 'WA', content: 'Washington', description: null }, { id: 179, type: 'STATE', dictKey: 'WV', content: 'West Virginia', description: null }, { id: 180, type: 'STATE', dictKey: 'WI', content: 'Wisconsin', description: null }, { id: 181, type: 'STATE', dictKey: 'WY', content: 'Wyoming', description: null },
];

export const helloklarityCondition = [{ id: 13235, type: 'HELLO_KLARITY_CONDITION', dictKey: 'adhd', content: 'ADHD', description: 'mental_health' }, { id: 13236, type: 'HELLO_KLARITY_CONDITION', dictKey: 'insomnia', content: 'Insomnia', description: 'mental_health' }, { id: 13237, type: 'HELLO_KLARITY_CONDITION', dictKey: 'depression', content: 'Depression', description: 'mental_health' }, { id: 13238, type: 'HELLO_KLARITY_CONDITION', dictKey: 'anxiety', content: 'Anxiety', description: 'mental_health' }, { id: 13239, type: 'HELLO_KLARITY_CONDITION', dictKey: 'ocd', content: 'OCD', description: 'mental_health' }, { id: 13240, type: 'HELLO_KLARITY_CONDITION', dictKey: 'asthma', content: 'Asthma', description: 'primary_and_preventive_care' }, { id: 13241, type: 'HELLO_KLARITY_CONDITION', dictKey: 'allergy', content: 'Allergy', description: 'primary_and_preventive_care' }, { id: 13242, type: 'HELLO_KLARITY_CONDITION', dictKey: 'cold-sore', content: 'Cold sore', description: 'primary_and_preventive_care' }, { id: 13243, type: 'HELLO_KLARITY_CONDITION', dictKey: 'migraine', content: 'Migraine', description: 'pain_management' }, { id: 13244, type: 'HELLO_KLARITY_CONDITION', dictKey: 'irritable-bowel-syndrome', content: 'Irritable bowel syndrome', description: 'primary_and_preventive_care' }, { id: 13245, type: 'HELLO_KLARITY_CONDITION', dictKey: 'lupus', content: 'Lupus', description: 'primary_and_preventive_care' }, { id: 13246, type: 'HELLO_KLARITY_CONDITION', dictKey: 'weight-loss', content: 'Weight loss', description: 'primary_and_preventive_care' }, { id: 13247, type: 'HELLO_KLARITY_CONDITION', dictKey: 'nutrition', content: 'Nutrition', description: 'primary_and_preventive_care' }, { id: 13248, type: 'HELLO_KLARITY_CONDITION', dictKey: 'diabetes', content: 'Diabetes', description: 'chronic_conditions' }, { id: 13249, type: 'HELLO_KLARITY_CONDITION', dictKey: 'heart-disease', content: 'Heart disease', description: 'chronic_conditions' }, { id: 13250, type: 'HELLO_KLARITY_CONDITION', dictKey: 'hypertension', content: 'Hypertension', description: 'chronic_conditions' }, { id: 13251, type: 'HELLO_KLARITY_CONDITION', dictKey: 'std', content: 'STD', description: 'infections' }, { id: 13252, type: 'HELLO_KLARITY_CONDITION', dictKey: 'yeast-infection', content: 'Yeast infection', description: 'infections' }, { id: 13253, type: 'HELLO_KLARITY_CONDITION', dictKey: 'uti', content: 'UTI', description: 'infections' }, { id: 13254, type: 'HELLO_KLARITY_CONDITION', dictKey: 'sinus-infection', content: 'Sinus infection', description: 'infections' }, { id: 13255, type: 'HELLO_KLARITY_CONDITION', dictKey: 'lyme-disease', content: 'Lyme disease', description: 'infections' }, { id: 13256, type: 'HELLO_KLARITY_CONDITION', dictKey: 'pneumonia', content: 'Pneumonia', description: 'infections' }, { id: 13257, type: 'HELLO_KLARITY_CONDITION', dictKey: 'back-pain', content: 'Back pain', description: 'pain_management' }, { id: 13258, type: 'HELLO_KLARITY_CONDITION', dictKey: 'fibromyalgia', content: 'Fibromyalgia', description: 'pain_management' }, { id: 13271, type: 'HELLO_KLARITY_CONDITION', dictKey: 'ptsd', content: 'PTSD', description: 'therapy_and_counseling' }, { id: 13272, type: 'HELLO_KLARITY_CONDITION', dictKey: 'mood-disorders', content: 'Mood disorders', description: 'therapy_and_counseling' }, { id: 13273, type: 'HELLO_KLARITY_CONDITION', dictKey: 'eating-disorders', content: 'Eating disorders', description: 'therapy_and_counseling' }, { id: 13274, type: 'HELLO_KLARITY_CONDITION', dictKey: 'panic-attacks', content: 'Panic attacks', description: 'therapy_and_counseling' }];
